(function () {
  // Read the global setting (defaults to true if not set).
  function isNotificationEnabled() {
    const settings = window.themeSettings || {};
    return settings.cartAddedNotificationEnabled !== false;
  }

  // "View cart" floating pill — stays in sync with the cart drawer.
  // Mobile-only (hidden on desktop via CSS); desktop gets the
  // .cart-added-toast bar at the top instead. Two thumbnails max in a
  // diagonal card-stack: newest sits at the top-right, fully visible
  // and on top; the older one peeks out from the bottom-left behind it.
  const VIEW_PILL_MAX_VISIBLE = 2;
  const VIEW_PILL_SIZE = 42; // px — all thumbnails share the same size
  // Small diagonal offset so the older thumbnail peeks out from
  // behind the newest one, hinting that there's a stack of items.
  const VIEW_PILL_OFFSET = 0;
  const VIEW_PILL_OFFSET_new = 9;
  let pendingAtcImageUrl = null;
  let pendingAtcVariantId = null;
  // Image + variant of the product the user just added. The next refresh
  // uses these to keep that thumbnail at the front of the stack, even
  // though Shopify's /cart.js returns items in first-added order (which
  // can push an existing line ahead of the one the user just touched).
  // Variant id is checked first because card image URLs don't always
  // normalize to the /cart.js URL (different size suffixes, variant
  // images, etc.).
  let lastAddedImageUrl = null;
  let lastAddedVariantId = null;
  let pillRefreshInFlight = null;

  function getCartItemCount() {
    const node = document.getElementById("cart_items_count");
    if (!node) return 0;
    const parsed = parseInt((node.textContent || "").trim(), 10);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function ensureCartViewPill() {
    if (!isNotificationEnabled()) return null;
    let pill = document.getElementById("cart-view-pill");
    if (pill) return pill;

    pill = document.createElement("button");
    pill.id = "cart-view-pill";
    pill.className = "cart-view-pill";
    pill.type = "button";
    pill.setAttribute("aria-label", "View cart");

    pill.innerHTML =
      '<span class="cart-view-pill__images" aria-hidden="true"></span>' +
      '<span class="cart-view-pill__text">' +
      '<span class="cart-view-pill__title">View cart</span>' +
      '<span class="cart-view-pill__count">0 Items</span>' +
      "</span>" +
      '<span class="cart-view-pill__arrow" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M9 6l6 6-6 6" stroke="#ffffff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>' +
      "</svg></span>";

    pill.addEventListener("click", function (event) {
      event.preventDefault();
      const headerCart =
        document.querySelector(".header-cart-link") ||
        document.querySelector("#cart-icon-bubble");
      if (headerCart) headerCart.click();
    });

    if (document.body) {
      document.body.appendChild(pill);
    }

    return pill;
  }

  function layoutPillImages(stack) {
    if (!stack) return;
    const images = Array.from(stack.querySelectorAll(".cart-view-pill__image"));
    const visibleCount = Math.min(images.length, VIEW_PILL_MAX_VISIBLE);

    // Drop older thumbnails beyond the visible window with a fade out.
    const overflow = images.length - visibleCount;
    for (let i = 0; i < overflow; i++) {
      const img = images[i];
      img.classList.add("is-leaving");
      window.setTimeout(function () {
        if (img.parentNode === stack) stack.removeChild(img);
      }, 320);
    }

    const visible = images.slice(overflow); // oldest first → newest last
    // Diagonal 2-card stack: newest sits at top-right with the highest
    // z-index; older peeks out at bottom-left behind it.
    for (let i = 0; i < visible.length; i++) {
      const img = visible[visible.length - 1 - i]; // i = distance from newest
      const left = i === 0 ? VIEW_PILL_OFFSET_new : 0;
      const top = i === 0 ? 0 : VIEW_PILL_OFFSET;

      img.style.width = VIEW_PILL_SIZE + "px";
      img.style.height = VIEW_PILL_SIZE + "px";
      img.style.left = left + "px";
      img.style.top = top + "px";
      img.style.zIndex = String(visible.length - i); // newest = highest
    }

    const slotSize = VIEW_PILL_SIZE + VIEW_PILL_OFFSET;
    stack.style.width = slotSize + "px";
    stack.style.height = slotSize + "px";
  }

  function addPillThumbnail(stack, imageUrl) {
    if (!stack || !imageUrl) return;

    const wrap = document.createElement("span");
    wrap.className = "cart-view-pill__image is-entering";

    const img = document.createElement("img");
    img.alt = "";
    img.loading = "lazy";
    img.src = imageUrl;
    wrap.appendChild(img);

    stack.appendChild(wrap);
    layoutPillImages(stack);

    // Trigger entry animation on next frame.
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        wrap.classList.remove("is-entering");
      });
    });
  }

  function updatePillCount(pill, count) {
    const countEl = pill.querySelector(".cart-view-pill__count");
    if (!countEl) return;
    const safe = Math.max(0, count | 0);
    countEl.textContent = safe + (safe === 1 ? " Item" : " Items");
  }

  function rebuildPillStack(stack, urls) {
    if (!stack) return;
    Array.from(stack.querySelectorAll(".cart-view-pill__image")).forEach(
      function (el) {
        el.remove();
      }
    );
    urls.forEach(function (url) {
      const wrap = document.createElement("span");
      wrap.className = "cart-view-pill__image";
      const img = document.createElement("img");
      img.alt = "";
      img.loading = "lazy";
      img.src = url;
      wrap.appendChild(img);
      stack.appendChild(wrap);
    });
    layoutPillImages(stack);
  }

  function getCartItemImageUrl(item) {
    if (!item) return null;
    if (item.featured_image && item.featured_image.url) {
      return item.featured_image.url;
    }
    return item.image || null;
  }

  // Strip Shopify size suffix + query so URLs from product card markup
  // (e.g. `..._180x180.jpg`) compare equal to /cart.js URLs of the same
  // image. Used to decide whether the post-add reconcile actually needs
  // to rebuild the stack — if not, we preserve the entry animation.
  function normalizeImageUrl(url) {
    if (!url) return "";
    let path;
    try {
      path = new URL(url, window.location.origin).pathname;
    } catch (e) {
      path = String(url).split("?")[0];
    }
    return path.replace(/_(\d+)x(\d*)(@\dx)?(\.[a-z0-9]+)$/i, "$4");
  }

  function getCurrentStackUrls(stack) {
    if (!stack) return [];
    return Array.from(stack.querySelectorAll(".cart-view-pill__image img"))
      .map(function (img) {
        return img.getAttribute("src") || "";
      });
  }

  function urlListsMatch(a, b) {
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
      if (normalizeImageUrl(a[i]) !== normalizeImageUrl(b[i])) return false;
    }
    return true;
  }

  // Pull the authoritative cart state and re-render the pill from it.
  // Called on init, after cart changes (quantity/remove/clear), and as a
  // safety reconcile after add. No entry animation — instant rebuild.
  // Reconcile the floating pill from the server, but ONLY when it's actually on
  // screen. Cart mutations (qty +/-, remove) fire a /cart.js fetch via the
  // fetch/XHR wrappers to keep the pill thumbnails fresh — yet the pill is a
  // post-add overlay that's hidden during normal drawer editing, so that fetch
  // was racing the section render for nothing. Skip it when the pill is hidden.
  function refreshPillIfVisible() {
    if (!isNotificationEnabled()) return Promise.resolve();
    const pill = document.getElementById("cart-view-pill");
    if (!pill || !pill.classList.contains("is-visible")) return Promise.resolve();
    return refreshCartViewPillFromServer();
  }

  function refreshCartViewPillFromServer() {
    if (!isNotificationEnabled()) return Promise.resolve();
    if (pillRefreshInFlight) return pillRefreshInFlight;

    pillRefreshInFlight = fetch("/cart.js", {
      cache: "no-store",
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    })
      .then(function (r) {
        if (!r.ok) throw new Error("Cart sync failed");
        return r.json();
      })
      .then(function (cart) {
        // Snapshot + consume here (not at fetch start) so the values reflect
        // the most recent add by the time we apply them.
        const recentAddUrl = lastAddedImageUrl;
        const recentVariantId = lastAddedVariantId;
        lastAddedImageUrl = null;
        lastAddedVariantId = null;

        const pill = ensureCartViewPill();
        if (!pill) return;

        const stack = pill.querySelector(".cart-view-pill__images");

        if (!cart || !cart.item_count) {
          rebuildPillStack(stack, []);
          updatePillCount(pill, 0);
          pill.classList.remove("is-visible");
          return;
        }

        // Find the recently-added line in cart.items. Prefer variant_id
        // (always exact) and fall back to image-URL match (works when
        // the source isn't a theme form we can read).
        let recentItem = null;
        if (recentVariantId && cart.items) {
          recentItem = cart.items.find(function (item) {
            return String(item.variant_id) === String(recentVariantId);
          }) || null;
        }
        if (!recentItem && recentAddUrl && cart.items) {
          const normalizedRecent = normalizeImageUrl(recentAddUrl);
          recentItem = cart.items.find(function (item) {
            return (
              normalizeImageUrl(getCartItemImageUrl(item)) === normalizedRecent
            );
          }) || null;
        }

        const items = (cart.items || []).slice(-VIEW_PILL_MAX_VISIBLE);
        const urls = items.map(getCartItemImageUrl).filter(Boolean);

        // /cart.js orders items by when the LINE was first added — adding a
        // duplicate variant only increments quantity, so the line the user
        // just touched can end up before older lines. Pin the just-added
        // line's image to the end so the layout places it on top of the
        // card stack.
        if (recentItem) {
          const recentUrl = getCartItemImageUrl(recentItem);
          if (recentUrl) {
            const normalizedRecentUrl = normalizeImageUrl(recentUrl);
            const filtered = urls.filter(function (u) {
              return normalizeImageUrl(u) !== normalizedRecentUrl;
            });
            filtered.push(recentUrl);
            while (filtered.length > VIEW_PILL_MAX_VISIBLE) filtered.shift();
            urls.length = 0;
            for (let i = 0; i < filtered.length; i++) urls.push(filtered[i]);

            // The DOM thumbnail we just animated in was built with the
            // product-card image URL, which may not normalize to the
            // /cart.js URL we want to pin. Swap its src in-place so the
            // url-match comparison below succeeds and the entry animation
            // is preserved (no rebuild wipe).
            const stackImages = Array.from(
              stack.querySelectorAll(".cart-view-pill__image:not(.is-leaving) img")
            );
            const lastImg = stackImages[stackImages.length - 1];
            if (lastImg && lastImg.getAttribute("src") !== recentUrl) {
              lastImg.setAttribute("src", recentUrl);
            }
          }
        }

        // Skip the rebuild if the stack already matches the cart — keeps
        // the just-added thumbnail's entry animation intact.
        const currentUrls = getCurrentStackUrls(stack);
        if (!urlListsMatch(currentUrls, urls)) {
          rebuildPillStack(stack, urls);
        }
        updatePillCount(pill, cart.item_count);
        pill.classList.add("is-visible");
      })
      .catch(function () {
        syncCartViewPillFromDom();
      })
      .then(function () {
        pillRefreshInFlight = null;
      });

    return pillRefreshInFlight;
  }

  function showCartViewPillFromCart(cart) {
    if (!isNotificationEnabled() || !cart) return;

    const itemCount =
      typeof cart.item_count === "number"
        ? cart.item_count
        : typeof cart.quantity === "number"
          ? getCartItemCount()
          : 0;

    const pill = ensureCartViewPill();
    if (!pill) return;

    const stack = pill.querySelector(".cart-view-pill__images");

    if (!itemCount) {
      rebuildPillStack(stack, []);
      updatePillCount(pill, 0);
      pill.classList.remove("is-visible");
      return;
    }

    if (Array.isArray(cart.items)) {
      const urls = cart.items
        .slice(-VIEW_PILL_MAX_VISIBLE)
        .map(getCartItemImageUrl)
        .filter(Boolean);
      if (!urlListsMatch(getCurrentStackUrls(stack), urls)) {
        rebuildPillStack(stack, urls);
      }
    } else if (cart.quantity > 0) {
      const imageUrl = getCartItemImageUrl(cart);
      if (imageUrl) {
        const currentUrls = getCurrentStackUrls(stack);
        const lastUrl = currentUrls[currentUrls.length - 1] || "";
        if (normalizeImageUrl(lastUrl) !== normalizeImageUrl(imageUrl)) {
          addPillThumbnail(stack, imageUrl);
        }
      }
    }

    updatePillCount(pill, itemCount);
    pill.classList.add("is-visible");
  }

  function getCartViewPillDomSnapshot() {
    const rows = Array.from(
      document.querySelectorAll("#CartDrawer .cart-drawer-item")
    );
    const headerCount = getCartItemCount();

    if (!rows.length) {
      return headerCount > 0 ? { item_count: headerCount, items: [] } : null;
    }

    let rowQuantityTotal = 0;
    const items = rows
      .map(function (row) {
        const quantity = parseInt(row.getAttribute("data-quantity"), 10);
        rowQuantityTotal += Number.isFinite(quantity) && quantity > 0 ? quantity : 1;

        const image = row.querySelector(".cart-drawer-item__image, .cart-item__image");
        const imageUrl =
          (image &&
            (image.currentSrc ||
              image.getAttribute("src") ||
              image.getAttribute("data-src"))) ||
          null;

        return imageUrl ? { image: imageUrl } : null;
      })
      .filter(Boolean);

    return {
      item_count: headerCount > 0 ? headerCount : rowQuantityTotal,
      items: items,
    };
  }

  function syncCartViewPillFromDom() {
    const snapshot = getCartViewPillDomSnapshot();
    if (!snapshot || !snapshot.item_count) return false;
    showCartViewPillFromCart(snapshot);
    return true;
  }

  function getGridCartPayloadItemCount(cart) {
    if (cart && typeof cart.item_count === "number") return cart.item_count;

    const headerCount = getCartItemCount();
    if (headerCount > 0) return headerCount;

    if (cart && typeof cart.quantity === "number") return cart.quantity;
    return 0;
  }

  function syncCartDrawerFromGridPayload(cart) {
    if (cart && cart.sections) {
      applyCartSectionsState({
        item_count: getGridCartPayloadItemCount(cart),
        sections: cart.sections,
      });
      return Promise.resolve();
    }

    if (typeof recoverCartDrawerFromServer === "function") {
      return recoverCartDrawerFromServer();
    }

    return Promise.resolve();
  }

  document.addEventListener("grid-stepper:cart-changed", function (event) {
    // The stepper fires this for every cart write (add / + / -). The detail now
    // carries { cart, direction } so we can keep the view pill in sync with the
    // current count but only surface the "Product Added" notification when the
    // quantity actually went UP. Decreasing must show nothing.
    var detail = event.detail || {};
    var cart = detail.cart !== undefined ? detail.cart : detail;
    var direction = detail.direction;

    // Proactively refresh the drawer contents on every grid cart write. Newer
    // grid requests include fresh section HTML in the cart response, which avoids
    // a separate section-render fetch that can come back stale on collection
    // pages. Older payloads still fall back to the server recovery path.
    //
    // The dirty flag is NOT cleared up-front: it is cleared only once the refresh
    // actually succeeds, so a fast open() during the in-flight fetch still sees
    // the cart as dirty and awaits the same refresh (via window.__gridRefreshPromise)
    // instead of opening over a half-updated drawer.
    if ((cart && cart.sections) || typeof recoverCartDrawerFromServer === "function") {
      window.__gridRefreshPromise = Promise.resolve()
        .then(function () {
          return syncCartDrawerFromGridPayload(cart);
        })
        .then(function () {
          window.__gridStepperCartDirty = false;
        })
        .catch(function () {
          // Refresh failed — keep the dirty flag set so open() retries later.
          window.__gridStepperCartDirty = true;
        })
        .then(function () {
          window.__gridRefreshPromise = null;
        });
    }

    // On a decrease, surface nothing new: only keep an already-visible pill's
    // count in sync, never pop it open. On an increase, show the pill as usual.
    if (direction !== "up") {
      var existingPill = document.getElementById("cart-view-pill");
      if (existingPill && existingPill.classList.contains("is-visible")) {
        showCartViewPillFromCart(cart);
      }
      return;
    }

    showCartViewPillFromCart(cart);
    if (window.matchMedia && window.matchMedia("(min-width: 768px)").matches) {
      showCartAddedToast();
    }
  });

  // -------------------------------------------------------------
  // Desktop-only "Added to cart" top toast
  // -------------------------------------------------------------
  // Mirrors the mobile pill: appears on add, shows the product
  // thumbnail + item count + a "View cart" action, then auto-hides.
  // CSS gates visibility to >=768px, so this is harmless on mobile.

  const CART_TOAST_VISIBLE_MS = 3500;
  let cartToastHideTimer = null;

  function ensureCartAddedToast() {
    if (!isNotificationEnabled()) return null;
    let toast = document.getElementById("cart-added-toast");
    if (toast) return toast;

    toast = document.createElement("div");
    toast.id = "cart-added-toast";
    toast.className = "cart-added-toast";
    toast.setAttribute("role", "status");
    toast.setAttribute("aria-live", "polite");

    toast.innerHTML =
      '<span class="cart-added-toast__check" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M5 12.5l4 4 10-10" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>' +
      "</svg></span>" +
      '<span class="cart-added-toast__title">Product Added to Cart!</span>';

    if (document.body) document.body.appendChild(toast);
    return toast;
  }

  function showCartAddedToast() {
    const toast = ensureCartAddedToast();
    if (!toast) return;

    toast.classList.add("is-visible");
    if (cartToastHideTimer) window.clearTimeout(cartToastHideTimer);
    cartToastHideTimer = window.setTimeout(function () {
      toast.classList.remove("is-visible");
      cartToastHideTimer = null;
    }, CART_TOAST_VISIBLE_MS);
  }

  window.showCartAddedNotification = function () {
    if (!isNotificationEnabled()) return;
    const pill = ensureCartViewPill();
    if (!pill) return;

    const stack = pill.querySelector(".cart-view-pill__images");
    if (pendingAtcImageUrl) {
      addPillThumbnail(stack, pendingAtcImageUrl);
      lastAddedImageUrl = pendingAtcImageUrl;
      pendingAtcImageUrl = null;
    }
    if (pendingAtcVariantId) {
      lastAddedVariantId = pendingAtcVariantId;
      pendingAtcVariantId = null;
    }

    const count = getCartItemCount();
    updatePillCount(pill, count);
    pill.classList.add("is-visible");

    // "Product Added to Cart!" toast — shown on both mobile and desktop.
    showCartAddedToast();

    // Reconcile with server state after the entry animation settles, so
    // count/images match whatever the cart actually ended up with. The
    // refresh compares URLs first and skips rebuild if they already match,
    // so the just-animated thumbnail isn't wiped.
    window.setTimeout(refreshCartViewPillFromServer, 600);
  };

  window.refreshCartViewPill = refreshCartViewPillFromServer;

  // Kept for backwards-compat with the previous toast API; the pill is
  // now always synced to cart state so this is a no-op unless cart is
  // empty (in which case the refresh will hide it).
  window.hideCartAddedNotification = function () {
    refreshCartViewPillFromServer();
  };

  function initCartViewPill() {
    ensureCartViewPill();
    syncCartViewPillFromDom();
    // Sync to the current cart on every page load so the pill is shown
    // whenever the cart already has items — not only right after an add.
    // (CSS gates it to mobile; the refresh hides it again when the cart is
    // empty, so this is safe to call unconditionally.)
    refreshCartViewPillFromServer();
  }

  if (isNotificationEnabled()) {
    if (document.readyState !== "loading") {
      initCartViewPill();
    } else {
      document.addEventListener("DOMContentLoaded", initCartViewPill);
    }
    window.addEventListener("pageshow", function (event) {
      if (event.persisted) initCartViewPill();
    });
  }

  function captureProductImageFromButton(button) {
    if (!button) return null;
    const card =
      button.closest(".product-bx") ||
      button.closest(".prduct-filter") ||
      button.closest("[data-product-form]") ||
      button.closest("form") ||
      button.closest("article") ||
      button.parentElement;
    if (!card) return null;

    const img = card.querySelector(".prd-h-img img, img");
    if (!img) return null;

    return (
      img.currentSrc ||
      img.getAttribute("src") ||
      img.getAttribute("data-src") ||
      null
    );
  }

  function captureVariantIdFromButton(button) {
    if (!button) return null;
    if (button.dataset) {
      if (button.dataset.variantId) return button.dataset.variantId;
      if (button.dataset.id) return button.dataset.id;
    }
    const form = button.closest("form");
    if (!form) return null;
    const input = form.querySelector('input[name="id"]');
    return input && input.value ? input.value : null;
  }

  // -------------------------------------------------------------
  // Universal "real time on success" trigger
  // -------------------------------------------------------------
  // Hooks every /cart/add request (fetch + XHR) so the toast only
  // fires AFTER the server confirms the add succeeded. Works for
  // any source — theme forms, app cart drawers, custom widgets.

  function isCartAddUrl(url) {
    if (!url) return false;
    try {
      const path = new URL(url, window.location.origin).pathname;
      return /\/cart\/add(\.js)?$/.test(path);
    } catch (e) {
      return /\/cart\/add(\.js)?(\?|$)/.test(String(url));
    }
  }

  function isCartMutationUrl(url) {
    if (!url) return false;
    try {
      const path = new URL(url, window.location.origin).pathname;
      return /\/cart\/(change|update|clear)(\.js)?$/.test(path);
    } catch (e) {
      return /\/cart\/(change|update|clear)(\.js)?(\?|$)/.test(String(url));
    }
  }

  function requestHasHeader(input, init, name, expectedValue) {
    try {
      const initHeaders = init && init.headers ? new Headers(init.headers) : null;
      const inputHeaders = input && input.headers ? new Headers(input.headers) : null;
      const value =
        (initHeaders && initHeaders.get(name)) ||
        (inputHeaders && inputHeaders.get(name)) ||
        "";
      return expectedValue ? value === expectedValue : Boolean(value);
    } catch (e) {
      return false;
    }
  }

  function isGridStepperRequest(input, init) {
    return requestHasHeader(input, init, "X-Grid-Cart-Stepper", "1");
  }

  // Cart writes issued by the free-gift engine (assets/cart-free-gift.js) carry
  // this header. They must NOT fire the "Product Added" pill/toast or the
  // external-add drawer refresh — the gift engine refreshes the drawer itself
  // once its adds/removes settle.
  function isFreeGiftRequest(input, init) {
    return requestHasHeader(input, init, "X-Cart-Free-Gift", "1");
  }

  // -------------------------------------------------------------
  // Real-time loader on add-to-cart buttons (grid + product page)
  // -------------------------------------------------------------
  // ATC buttons use the class `.add-cart-btn`. The moment one is
  // clicked we add `.is-atc-loading` and inject a real spinner
  // element (styles injected into <head> by JS, so it works no
  // matter which stylesheets a given page loads). Cleared once the
  // cart add finishes, with a minimum visible time and a hard
  // safety timeout so the button can never get stuck.

  const ATC_MIN_LOADER_MS = 500; // minimum time the spinner stays visible
  const ATC_SAFETY_MS = 6000; // hard stop — clear even if nothing else fires
  const activeAtcButtons = new Map(); // button → { startedAt, safetyTimer }

  // Inject the loader styles once, directly into <head>.
  function injectAtcLoaderStyles() {
    if (document.getElementById("atc-loader-styles")) return;
    const style = document.createElement("style");
    style.id = "atc-loader-styles";
    style.textContent =
      ".add-cart-btn.is-atc-loading{position:relative!important;color:transparent!important;" +
      "cursor:wait!important;pointer-events:none!important;}" +
      ".add-cart-btn.is-atc-loading>*:not(.atc-spinner){visibility:hidden!important;opacity:0!important;}" +
      ".add-cart-btn .atc-spinner{position:absolute!important;top:50%!important;left:50%!important;" +
      "width:18px!important;height:18px!important;margin:-9px 0 0 -9px!important;" +
      "border:2px solid rgba(255,255,255,0.4)!important;border-top-color:#fff!important;" +
      "border-radius:50%!important;box-sizing:border-box!important;display:block!important;" +
      "visibility:visible!important;opacity:1!important;z-index:5!important;pointer-events:none!important;" +
      "animation:atc-btn-spin .7s linear infinite!important;}" +
      "@keyframes atc-btn-spin{to{transform:rotate(360deg);}}";
    (document.head || document.documentElement).appendChild(style);
  }

  if (document.head) {
    injectAtcLoaderStyles();
  } else {
    document.addEventListener("DOMContentLoaded", injectAtcLoaderStyles);
  }

  function isTrackableAtcButton(button) {
    if (!button || !button.classList.contains("add-cart-btn")) return false;
    // Applies to grid + product page (main & sticky ATC). Only the
    // cart drawer / quantity controls are excluded.
    if (button.closest("[data-grid-cart]")) return false;
    if (button.closest("#CartDrawer")) return false;
    if (button.closest("product-form")) return false;
    return true;
  }

  function markAtcButtonLoading(button) {
    if (!isTrackableAtcButton(button) || button.disabled) return;
    if (activeAtcButtons.has(button)) return;

    injectAtcLoaderStyles();
    button.classList.add("is-atc-loading");
    button.setAttribute("aria-busy", "true");

    // Inject a real spinner element (not a ::after pseudo) so it is
    // immune to any conflicting button styles in the theme.
    if (!button.querySelector(".atc-spinner")) {
      const spinner = document.createElement("span");
      spinner.className = "atc-spinner";
      spinner.setAttribute("aria-hidden", "true");
      button.appendChild(spinner);
    }

    const safetyTimer = window.setTimeout(function () {
      removeAtcButtonLoading(button);
    }, ATC_SAFETY_MS);

    activeAtcButtons.set(button, { startedAt: Date.now(), safetyTimer: safetyTimer });
  }

  function removeAtcButtonLoading(button) {
    const entry = activeAtcButtons.get(button);
    if (!entry) return;
    window.clearTimeout(entry.safetyTimer);
    activeAtcButtons.delete(button);
    button.classList.remove("is-atc-loading");
    button.removeAttribute("aria-busy");
    const spinner = button.querySelector(".atc-spinner");
    if (spinner) spinner.remove();
  }

  function clearAtcButtonLoading() {
    activeAtcButtons.forEach(function (entry, button) {
      const elapsed = Date.now() - entry.startedAt;
      const wait = Math.max(0, ATC_MIN_LOADER_MS - elapsed);
      window.setTimeout(function () {
        removeAtcButtonLoading(button);
      }, wait);
    });
  }

  // Add the spinner the instant a grid ATC button is pressed.
  document.addEventListener(
    "click",
    function (event) {
      const target = event.target;
      if (!target || !target.closest) return;
      const button = target.closest(".add-cart-btn");
      if (button && !button.closest("[data-grid-cart]")) {
        const imgUrl = captureProductImageFromButton(button);
        if (imgUrl) pendingAtcImageUrl = imgUrl;
        const variantId = captureVariantIdFromButton(button);
        if (variantId) pendingAtcVariantId = variantId;
      }
      markAtcButtonLoading(button);
    },
    true
  );

  // Backup: form submitted without a tracked click.
  document.addEventListener(
    "submit",
    function (event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const action = form.getAttribute("action") || "";
      if (action.indexOf("/cart/add") === -1) return;
      if (form.querySelector("[data-grid-cart]")) return;
      const button = form.querySelector(".add-cart-btn");
      if (button && !pendingAtcImageUrl) {
        const imgUrl = captureProductImageFromButton(button);
        if (imgUrl) pendingAtcImageUrl = imgUrl;
      }
      if (!pendingAtcVariantId) {
        const input = form.querySelector('input[name="id"]');
        if (input && input.value) pendingAtcVariantId = input.value;
      }
      markAtcButtonLoading(button);
    },
    true
  );

  // Clear once the cart add completes (event fired by submitCartForm).
  document.addEventListener("theme:cart:added", clearAtcButtonLoading);

  // When the custom drawer engine handles an add itself it already
  // re-renders the drawer (applyCartDrawerPayload), so a second server
  // refresh would be wasted work. It signals that via theme:cart:added;
  // we note the timestamp and skip the fallback refresh right after.
  let lastSelfRenderedAddAt = 0;
  document.addEventListener("theme:cart:added", function () {
    lastSelfRenderedAddAt = Date.now();
  });

  // Adds that come from other sources (Dawn's <product-form> notification
  // path, app widgets) update the cart but NOT the drawer footer, so the
  // Buy 1 Get 1 bar / totals would stay stale until reload. Re-pull just the
  // drawer section through the existing reconcile path so the bar reflects
  // the new cart on the next open. Reuses recoverCartDrawerFromServer (which
  // routes through applyCartSectionsState → swapDrawerFooter).
  function refreshDrawerAfterExternalAdd() {
    // If WE just rendered the drawer from the add response, the section HTML is
    // already fresh — fetching cart-drawer again is pure waste (the #1 cause of
    // slow adds). Bail before any network call in that case.
    if (Date.now() - lastSelfRenderedAddAt < 1500) return;

    // Only EXTERNAL adds (app widgets / raw forms not routed through our submit
    // handler or Dawn's <product-form>) reach here without a self-render, so the
    // drawer footer/milestone would otherwise be stale. Re-pull the section once.
    const refresh = recoverCartDrawerFromServer();

    // With the "Added to cart" notification OFF, any add should open the drawer
    // (matching the managed renderContents path). With it ON, the pill/toast is
    // the feedback and the drawer stays closed — nothing extra to do.
    if (isNotificationEnabled()) return;
    const openDrawer = function () {
      const cartDrawer = getCartDrawer();
      if (cartDrawer && !cartDrawer.classList.contains("active")) {
        cartDrawer.open();
      }
    };
    if (refresh && typeof refresh.then === "function") {
      refresh.then(openDrawer);
    } else {
      window.setTimeout(openDrawer, 120);
    }
  }

  // Fetch wrapper — show toast only when /cart/add returns success.
  if (window.fetch && !window.fetch.__cartToastWrapped) {
    const originalFetch = window.fetch;
    const wrapped = function (input) {
      const init = arguments[1];
      let url = "";
      if (typeof input === "string") {
        url = input;
      } else if (input && typeof input.url === "string") {
        url = input.url;
      }

      const isGridStepper = isGridStepperRequest(input, init);
      const isAdd = isCartAddUrl(url);
      const isMutation = !isAdd && isCartMutationUrl(url);
      const promise = originalFetch.apply(this, arguments);

      if (isGridStepper || isFreeGiftRequest(input, init)) return promise;

      if (isAdd) {
        promise
          .then(function (response) {
            clearAtcButtonLoading();
            if (response && response.ok && isNotificationEnabled()) {
              window.showCartAddedNotification();
            }
            if (response && response.ok) {
              window.setTimeout(refreshDrawerAfterExternalAdd, 60);
            }
          })
          .catch(function () {
            clearAtcButtonLoading();
          });
      } else if (isMutation) {
        promise
          .then(function (response) {
            if (response && response.ok && isNotificationEnabled()) {
              // Give Shopify a tick to finish writing the cart, then sync the
              // pill — but only if it's visible (skips a wasted /cart.js during
              // ordinary in-drawer qty/remove edits).
              window.setTimeout(refreshPillIfVisible, 50);
            }
          })
          .catch(function () {});
      }

      return promise;
    };
    wrapped.__cartToastWrapped = true;
    window.fetch = wrapped;
  }

  // XHR wrapper — same idea, for older add-to-cart code (jQuery etc.)
  if (window.XMLHttpRequest && !XMLHttpRequest.prototype.__cartToastWrapped) {
    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__cartToastIsAdd = isCartAddUrl(url);
      this.__cartToastIsMutation = !this.__cartToastIsAdd && isCartMutationUrl(url);
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      if (this.__cartToastIsAdd) {
        this.addEventListener("load", function () {
          clearAtcButtonLoading();
          if (
            this.status >= 200 &&
            this.status < 300 &&
            isNotificationEnabled()
          ) {
            window.showCartAddedNotification();
          }
          if (this.status >= 200 && this.status < 300) {
            window.setTimeout(refreshDrawerAfterExternalAdd, 60);
          }
        });
        this.addEventListener("error", clearAtcButtonLoading);
        this.addEventListener("abort", clearAtcButtonLoading);
      } else if (this.__cartToastIsMutation) {
        this.addEventListener("load", function () {
          if (
            this.status >= 200 &&
            this.status < 300 &&
            isNotificationEnabled()
          ) {
            // Pill sync only when it's on screen — see refreshPillIfVisible.
            window.setTimeout(refreshPillIfVisible, 50);
          }
        });
      }
      return originalSend.apply(this, arguments);
    };

    XMLHttpRequest.prototype.__cartToastWrapped = true;
  }

  // -------------------------------------------------------------
  // Serialized, key-based cart line updates + partial drawer render
  // -------------------------------------------------------------
  // Only one /cart/change request is in flight at a time and rapid
  // +/-/remove clicks are coalesced per line-item key, so requests
  // can't race each other or hit line indexes that shifted after a
  // removal. Re-renders swap only the drawer blocks whose HTML
  // actually changed instead of rebuilding the whole drawer DOM.

  const LINE_UPDATE_DEBOUNCE_MS = 300;
  const pendingLineUpdates = new Map(); // mapKey -> queued update
  const lineDebounceTimers = new Map(); // mapKey -> timeout id
  let lineUpdateInFlight = false;

  // The user's LATEST intended state per line key, set the instant they click
  // (optimistically), cleared only once the server confirms that exact value.
  //   pendingIntent.get(key) === 0    → user removed this line
  //   pendingIntent.get(key) === N    → user wants quantity N
  // The DOM reconcile consults this so a slow/stale /cart/change response can
  // never resurrect a line the user already removed, nor revert a quantity they
  // already changed again — the root cause of "remove 3 fast, 2 come back".
  const pendingIntent = new Map(); // key -> intended quantity (0 = removed)

  // Minimal drawer-wide "working" indicator: a slim progress bar under the
  // header, shown whenever ANY line update is queued, debouncing, or in flight,
  // and hidden once everything settles. Non-blocking — the drawer stays usable.
  function setDrawerBusy(isBusy) {
    const cartDrawer = getCartDrawer();
    if (cartDrawer) cartDrawer.classList.toggle("cd-busy", !!isBusy);
  }

  // ---- Cart-wide control lock -------------------------------------------------
  // While any update is in flight we disable EVERY quantity +/- and EVERY remove
  // button on ALL rows (not just the touched one). This is the structural fix for
  // the "edit two at once → only one updates" race: a second action simply can't
  // be issued mid-flight. The close button, checkout, scrolling, and the steal
  // rail stay fully usable — only the per-line quantity/remove controls lock.
  let cartLocked = false;
  let cartLockSafetyTimer = null;
  const CART_LOCK_SAFETY_MS = 8000; // hard release so a hung request can't freeze the cart

  function setCartControlsLocked(locked) {
    cartLocked = !!locked;
    const drawerRoot = document.getElementById("CartDrawer");
    if (!drawerRoot) return;

    // The line-items container carries the dim/disable styling (.cd-locked).
    const itemsHost =
      drawerRoot.querySelector(".cart-drawer__items-wrapper") ||
      drawerRoot.querySelector("#CartDrawer-CartItems") ||
      drawerRoot;
    itemsHost.classList.toggle("cd-locked", cartLocked);

    // Also mark the controls aria-disabled so it's not CSS-only (keyboard/AT).
    drawerRoot
      .querySelectorAll(".quantity__button, cart-remove-button, cart-remove-button button")
      .forEach(function (el) {
        if (cartLocked) el.setAttribute("aria-disabled", "true");
        else el.removeAttribute("aria-disabled");
      });

    // Safety: never stay locked forever. Cleared on the next unlock.
    if (cartLocked) {
      if (cartLockSafetyTimer) window.clearTimeout(cartLockSafetyTimer);
      cartLockSafetyTimer = window.setTimeout(function () {
        setCartControlsLocked(false);
      }, CART_LOCK_SAFETY_MS);
    } else if (cartLockSafetyTimer) {
      window.clearTimeout(cartLockSafetyTimer);
      cartLockSafetyTimer = null;
    }
  }

  // The drawer is busy if a request is mid-flight, queued, or still debouncing.
  // Busy also drives the cart-wide control lock so the two can't drift apart —
  // the lock engages with the first accepted action and releases when the queue
  // is fully drained (success or error), with the safety timer as a backstop.
  function recomputeDrawerBusy() {
    const busy =
      lineUpdateInFlight ||
      pendingLineUpdates.size > 0 ||
      lineDebounceTimers.size > 0;
    setDrawerBusy(busy);
    setCartControlsLocked(busy);
  }

  function bindDrawerOverlay() {
    const overlay = document.getElementById("CartDrawer-Overlay");
    if (!overlay || overlay.dataset.drawerCloseBound === "true") return;
    overlay.dataset.drawerCloseBound = "true";
    overlay.addEventListener("click", function () {
      const cartDrawer = getCartDrawer();
      if (cartDrawer) cartDrawer.close();
    });
  }

  function swapDrawerBlock(currentRoot, newRoot, selector) {
    const current = currentRoot.querySelector(selector);
    const next = newRoot.querySelector(selector);
    if (!current || !next) return;
    if (current.outerHTML === next.outerHTML) return;
    current.replaceWith(next);
  }

  // Generic appear / replace / remove for a block that can come and go between
  // cart states (e.g. the inline savings banner only exists when there's a
  // discount). New blocks are inserted at the same position the new render put
  // them by anchoring to the new render's previous sibling selector when known;
  // for simplicity we append into the same parent as the new node's parent
  // analogue. Here we keep it simple: if it newly appears, clone it in place
  // relative to its siblings by re-querying the parent chain.
  function reconcileBlock(currentRoot, newRoot, selector) {
    const current = currentRoot.querySelector(selector);
    const next = newRoot.querySelector(selector);
    if (current && next) {
      if (current.outerHTML !== next.outerHTML) current.replaceWith(next);
    } else if (current && !next) {
      current.remove();
    } else if (!current && next) {
      // Find the new node's parent by class so we can insert into the live DOM.
      const newParent = next.parentElement;
      if (!newParent) return;
      const parentSelector = newParent.id
        ? "#" + newParent.id
        : "." + Array.from(newParent.classList).join(".");
      const liveParent =
        (newParent.id && currentRoot.querySelector("#" + newParent.id)) ||
        (parentSelector && currentRoot.querySelector(parentSelector)) ||
        currentRoot;
      // Insert before the node that follows it in the new render, if present live.
      const nextSibling = next.nextElementSibling;
      let liveAnchor = null;
      if (nextSibling) {
        const sibSel = nextSibling.id
          ? "#" + nextSibling.id
          : "." + Array.from(nextSibling.classList).join(".");
        liveAnchor = sibSel ? liveParent.querySelector(sibSel) : null;
      }
      if (liveAnchor) {
        liveParent.insertBefore(next, liveAnchor);
      } else {
        liveParent.appendChild(next);
      }
    }
  }

  // Swap the Steal-the-deal rail's collection cards while preserving any
  // recommendations the lazy loader already fetched into the rail. The recs
  // loader stamps the rail with data-steal-recs-loaded="true"; once stamped we
  // leave the rail's card list alone (only the in-cart "Added" states could go
  // stale, which the next open's reconcile handles cheaply via card refresh).
  function swapStealRail(currentInner, newInner) {
    const currentSteal = currentInner.querySelector(".cart-drawer__steal");
    const newSteal = newInner.querySelector(".cart-drawer__steal");
    if (!currentSteal || !newSteal) {
      // Appear / disappear of the whole steal section — let reconcileBlock handle.
      reconcileBlock(currentInner, newInner, ".cart-drawer__steal");
      return;
    }
    const currentRail = currentSteal.querySelector("[data-steal-rail]");
    // If recs were lazily loaded, don't let the server render (which lacks them)
    // wipe the rail — keep the current rail's contents entirely.
    if (currentRail && currentRail.dataset.stealRecsLoaded === "true") {
      return;
    }
    if (currentSteal.outerHTML !== newSteal.outerHTML) {
      // Preserve the user's collapse state across the swap.
      const wasCollapsed = currentSteal.classList.contains("is-collapsed");
      const activeTab = currentSteal.querySelector("[data-steal-tab][aria-selected='true']");
      const activeTarget = activeTab && activeTab.getAttribute("data-steal-tab-target");
      currentSteal.replaceWith(newSteal);
      newSteal.classList.toggle("is-collapsed", wasCollapsed);
      if (activeTarget) activateStealTab(newSteal, activeTarget);
    }
  }

  // Reconcile cart rows BY STABLE KEY (not by index). Indexes shift the moment
  // any line is removed, so the old positional swap could drop a stale server
  // render into the wrong slot and resurrect rows the user had already removed.
  // Matching on data-key makes the reconcile order-independent and lets us honour
  // pendingIntent so an in-flight response never undoes a newer user action.
  function lineKeyOf(node) {
    return (node && node.getAttribute && node.getAttribute("data-key")) || null;
  }

  function swapDrawerLineItems(currentInner, newInner) {
    const currentWrap = currentInner.querySelector(".cart-drawer__items-wrapper");
    const newWrap = newInner.querySelector(".cart-drawer__items-wrapper");
    if (!currentWrap || !newWrap) {
      swapDrawerBlock(currentInner, newInner, ".drawer__cart-items-wrapper");
      return;
    }

    const currentItems = Array.from(currentWrap.children);
    const newItems = Array.from(newWrap.children);

    // Index the freshly rendered rows by key.
    const newByKey = new Map();
    const newOrder = [];
    for (const node of newItems) {
      const key = lineKeyOf(node);
      if (key) {
        newByKey.set(key, node);
        newOrder.push(key);
      }
    }

    // 1) Update / remove existing rows, keyed.
    const currentByKey = new Map();
    for (const node of currentItems) {
      const key = lineKeyOf(node);
      if (!key) {
        // Keyless row (shouldn't happen) — fall back to removing if absent.
        node.remove();
        continue;
      }
      currentByKey.set(key, node);

      const intent = pendingIntent.get(key);
      const incoming = newByKey.get(key);

      // The user removed this line and THIS response confirms it (the server no
      // longer has the line). Detach the row now — there is no optimistic removal
      // any more, so the row lived in the DOM with its spinner until exactly this
      // confirmation. A short fade plays as it leaves (after confirmation, never
      // before). A stale response that still lists the line is handled below.
      if (intent === 0) {
        if (!incoming) {
          if (!node.classList.contains("is-removing")) {
            node.classList.add("is-removing");
            window.setTimeout(function () {
              if (node.parentNode) node.remove();
            }, 200);
          }
        }
        // If the line is somehow still present server-side (stale/again-added),
        // leave the row until a response that actually confirms the removal.
        continue;
      }

      if (!incoming) {
        // Server no longer has this line. If the user still wants it (a pending
        // non-zero intent the server hasn't caught up to), leave the row; else
        // it's genuinely gone.
        if (intent === undefined) node.remove();
        continue;
      }

      // Row still exists server-side. If the user has a pending quantity change
      // that this response doesn't yet reflect, don't clobber their optimistic
      // value — leave the live row until the confirming response lands.
      const incomingQty = incoming.getAttribute("data-quantity");
      if (
        intent !== undefined &&
        incomingQty !== null &&
        parseInt(incomingQty, 10) !== intent
      ) {
        continue;
      }

      if (node.outerHTML !== incoming.outerHTML) {
        node.replaceWith(incoming);
      }
    }

    // 2) Append rows the server has that we don't — but never re-add a line the
    // user just removed (pendingIntent === 0).
    let anchor = null;
    for (const key of newOrder) {
      if (currentByKey.has(key)) {
        anchor = currentWrap.querySelector('[data-key="' + cssEscape(key) + '"]');
        continue;
      }
      if (pendingIntent.get(key) === 0) continue;
      const node = newByKey.get(key);
      if (anchor && anchor.parentNode === currentWrap) {
        anchor.insertAdjacentElement("afterend", node);
      } else {
        currentWrap.appendChild(node);
      }
      anchor = node;
    }
  }

  // Minimal CSS.escape fallback (cart keys are alphanumeric + ':') for older
  // browsers without CSS.escape.
  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === "function") {
      return window.CSS.escape(value);
    }
    return String(value).replace(/["\\]/g, "\\$&");
  }

  function applyCartDrawerSectionHtml(html) {
    if (!html) return false;
    const drawerRoot = document.getElementById("CartDrawer");
    if (!drawerRoot) return false;

    const parsedDoc = new DOMParser().parseFromString(html, "text/html");
    const newInner = parsedDoc.querySelector(".drawer__inner");
    const currentInner = drawerRoot.querySelector(".drawer__inner");
    if (!newInner || !currentInner) return false;

    const newIsEmpty = Boolean(newInner.querySelector(".drawer__inner-empty"));
    const currentIsEmpty = Boolean(currentInner.querySelector(".drawer__inner-empty"));

    // Empty <-> filled transitions change the drawer's whole structure;
    // fall back to a full swap for those (rare) renders.
    if (newIsEmpty || currentIsEmpty) {
      currentInner.innerHTML = newInner.innerHTML;
      return true;
    }

    swapDrawerBlock(currentInner, newInner, ".cart-drawer__count-badge");
    swapDrawerBlock(currentInner, newInner, ".cart-drawer__free-shipping-bar");
    swapDrawerBlock(currentInner, newInner, ".cart-drawer__milestone");
    swapDrawerLineItems(currentInner, newInner);
    // Applied-coupons rail: automatic-coupon saved amounts track the cart.
    swapDrawerBlock(currentInner, newInner, ".cart-drawer__coupon-rail");
    // Free-gift strip + freebies panel: both appear/disappear as tiers
    // lock/unlock, so they need the add/remove-aware reconcile, not a plain
    // swap. (The freebies panel is a SIBLING of .cart-drawer__items-wrapper,
    // so the keyed row-reconcile above never touches it.)
    reconcileBlock(currentInner, newInner, ".cart-drawer__gift-bar");
    reconcileBlock(currentInner, newInner, ".cart-drawer__freebies");
    // Cashback line: amount and nudge track the cart total, and the line
    // can appear/disappear (e.g. nudge text blank below the target).
    reconcileBlock(currentInner, newInner, ".cart-drawer__cashback");
    // The Steal-the-deal / FBT grid is the heaviest block; only re-render it
    // when an add/remove actually changed its in-cart states. Preserve a
    // lazily-loaded recommendations rail so the swap doesn't wipe fetched recs.
    swapStealRail(currentInner, newInner);
    swapDrawerBlock(currentInner, newInner, ".cart-drawer__fbt:not(.cart-drawer__steal)");
    // NOTE: the price-summary block (.cart-drawer__summary) moved into the sticky
    // footer — it is swapped inside swapDrawerFooter() now, not here.
    swapDrawerFooter(currentInner, newInner);
    return true;
  }

  // The fixed footer isn't in the block list above, but it now carries the
  // live total price + savings banner + Buy 1 Get 1 bar. Swap just those —
  // never the gokwik button, whose enabled state is bound by the app's own
  // script.
  function swapDrawerFooter(currentInner, newInner) {
    // Price-summary dropdown — swapped wholesale (it now lives in the footer and
    // carries the live total + breakdown + savings strip as one unit). Replacing
    // it resets the markup to its default collapse state, so reapply the user's
    // open/closed choice straight after.
    swapDrawerBlock(currentInner, newInner, ".cart-drawer__summary");
    applyPriceDetailsState();

    const currentFooter = currentInner.querySelector(".cart-drawer__footer");
    const newFooter = newInner.querySelector(".cart-drawer__footer");
    if (!currentFooter || !newFooter) return;

    // The Buy 1 Get 1 bar appears only when exactly one eligible unit is
    // in the cart, so it needs the appear/disappear cases — not just a swap.
    reconcileFooterBlock(
      currentFooter,
      newFooter,
      ".cart-drawer__b1g1-bar"
    );

    // Reward strip (sticky checkout) mirrors the milestone next-tier message;
    // it disappears once every tier is unlocked, so it needs appear/disappear.
    reconcileFooterBlock(
      currentFooter,
      newFooter,
      ".cart-drawer__reward-strip"
    );

    // Best-deal bar — appears/disappears and changes amount with the cart (it
    // tracks the single highest qualifying coupon). Reconciled LAST so its
    // insert-at-footer-top lands it above every other footer banner.
    reconcileFooterBlock(
      currentFooter,
      newFooter,
      ".cart-drawer__best-deal-bar"
    );
  }

  // Add / remove / replace a footer block so it tracks the freshly rendered
  // section even when it appears or disappears between cart states. New blocks
  // are inserted at the top of the footer to keep the banner stack order.
  function reconcileFooterBlock(currentFooter, newFooter, selector) {
    const currentBlock = currentFooter.querySelector(selector);
    const newBlock = newFooter.querySelector(selector);
    if (currentBlock && newBlock) {
      if (currentBlock.outerHTML !== newBlock.outerHTML) {
        currentBlock.replaceWith(newBlock);
      }
    } else if (currentBlock && !newBlock) {
      currentBlock.remove();
    } else if (!currentBlock && newBlock) {
      currentFooter.insertBefore(newBlock, currentFooter.firstChild);
    }
  }

  function sectionHtmlIsEmpty(sectionHtml) {
    if (!sectionHtml) return true;
    const doc = new DOMParser().parseFromString(sectionHtml, "text/html");
    const drawerEl = doc.querySelector("cart-drawer");
    if (drawerEl && drawerEl.classList.contains("is-empty")) return true;
    return Boolean(doc.querySelector(".drawer__inner-empty"));
  }

  function applyCartSectionsState(parsedState) {
    const sections = (parsedState && parsedState.sections) || {};
    const isEmpty = !parsedState || !parsedState.item_count;

    // Guard against a stale/cached section render: if the caller knows the cart
    // has items (item_count > 0) but the drawer HTML came back as the empty-cart
    // markup, applying it would blank a real cart. Skip the body swap in that
    // case and keep whatever non-empty markup is already on screen — the count
    // and is-empty class below still get corrected.
    const drawerHtml = sections["cart-drawer"];
    const staleEmptyRender =
      !isEmpty && drawerHtml && sectionHtmlIsEmpty(drawerHtml);

    const cartDrawer = getCartDrawer();
    if (cartDrawer) cartDrawer.classList.toggle("is-empty", isEmpty);
    const drawerItems = document.querySelector("cart-drawer-items");
    if (drawerItems) drawerItems.classList.toggle("is-empty", isEmpty);

    if (!staleEmptyRender && drawerHtml && !applyCartDrawerSectionHtml(drawerHtml)) {
      // Fallback — replace the whole drawer like the original code did.
      const target = document.getElementById("CartDrawer");
      const source = new DOMParser()
        .parseFromString(sections["cart-drawer"], "text/html")
        .querySelector("#CartDrawer");
      if (target && source) target.innerHTML = source.innerHTML;
    }
    bindDrawerOverlay();

    const bubble = document.getElementById("cart-icon-bubble");
    if (bubble && sections["cart-icon-bubble"]) {
      bubble.innerHTML = sections["cart-icon-bubble"];
    }

    const errors = document.getElementById("CartDrawer-CartErrors");
    if (errors) errors.textContent = "";

    // The milestone block is replaced wholesale by the swap above, detaching the
    // scoped observer from the old node. Re-arm it against the fresh block and
    // run the celebration check once — the new block already carries the latest
    // data-milestone-unlocked, so no subtree observer is needed to notice it.
    if (sections["cart-drawer"]) setupMilestoneObserver();
    if (sections["cart-drawer"]) fillWalletNote();
  }

  // ---- "Price details" collapse ---------------------------------------
  // The price-summary dropdown now lives in the footer and defaults to COLLAPSED
  // (the merchant can flip that via price_details_collapsed_default). The state
  // lives in a module flag (not the DOM) because the summary block is re-rendered
  // wholesale on every cart update; we reapply the flag after each render so the
  // dropdown doesn't snap back to its default on a qty change. The flag is seeded
  // ONCE from whatever collapse state the first server render emitted, so the
  // merchant's default-open/closed setting is honoured without hardcoding it.
  let priceDetailsCollapsed = null;

  function applyPriceDetailsState() {
    const summary = document.querySelector("#CartDrawer .cart-drawer__summary");
    if (!summary) return;
    if (priceDetailsCollapsed === null) {
      priceDetailsCollapsed = summary.classList.contains("is-collapsed");
    }
    summary.classList.toggle("is-collapsed", priceDetailsCollapsed);
    const toggle = summary.querySelector(".cart-drawer__pricedetails-toggle");
    if (toggle) toggle.setAttribute("aria-expanded", String(!priceDetailsCollapsed));
  }

  document.addEventListener("click", function (event) {
    const node = event.target;
    const toggle =
      node && node.closest ? node.closest(".cart-drawer__pricedetails-toggle") : null;
    if (!toggle) return;
    // Seed from the live DOM if no cart mutation has run yet (flag still null),
    // so the very first tap toggles relative to the rendered default.
    if (priceDetailsCollapsed === null) {
      const summary = toggle.closest(".cart-drawer__summary");
      priceDetailsCollapsed = summary ? summary.classList.contains("is-collapsed") : true;
    }
    priceDetailsCollapsed = !priceDetailsCollapsed;
    applyPriceDetailsState();
  });

  // Spinner shown in place of the quantity number while a line update is
  // in flight (incl. the debounce window). Cleared when the row re-renders
  // from the server, or by setLineLoading(false) if the row didn't change.
  function setLineQuantityLoading(line, isLoading) {
    const lineItem = document.getElementById("CartDrawer-Item-" + line);
    if (!lineItem) return;
    const stepper = lineItem.querySelector(".cart-drawer-item__quantity .quantity");
    if (stepper) stepper.classList.toggle("is-qty-loading", isLoading);
  }

  // Spinner on a row's REMOVE control while its delete is confirming. The row
  // stays in the DOM (no optimistic removal); .is-deleting swaps the trash icon
  // for a spinner via CSS. The row is detached only by the confirming reconcile.
  function setLineDeleting(line, isDeleting) {
    const lineItem = document.getElementById("CartDrawer-Item-" + line);
    if (!lineItem) return;
    const removeBtn = lineItem.querySelector(".cart-drawer-item__remove");
    if (removeBtn) removeBtn.classList.toggle("is-deleting", isDeleting);
  }

  // Optimistically paint a line's price as qty × unit price, using the per-unit
  // prices stamped on the row (data-unit-final-price / data-unit-original-price,
  // both in cents). The server response reconciles the exact value (incl. any
  // automatic discounts) a moment later, so an approximation here is fine.
  function paintOptimisticLinePrice(lineItem, quantity) {
    if (!lineItem) return;
    const unitFinal = parseInt(lineItem.getAttribute("data-unit-final-price"), 10);
    if (!Number.isFinite(unitFinal)) return;
    const unitOriginal = parseInt(lineItem.getAttribute("data-unit-original-price"), 10);

    const nowEl = lineItem.querySelector(".cart-drawer-item__price-now");
    if (nowEl) nowEl.textContent = formatMoneyValue(unitFinal * quantity);

    const oldEl = lineItem.querySelector(".cart-item__old-price");
    if (oldEl && Number.isFinite(unitOriginal) && unitOriginal > unitFinal) {
      oldEl.textContent = formatMoneyValue(unitOriginal * quantity);
    }
  }

  function setLineLoading(line, isLoading) {
    const lineItem = document.getElementById("CartDrawer-Item-" + line);
    if (!lineItem) return;
    if (!isLoading) {
      lineItem.classList.remove("is-removing");
      // Clear the delete spinner too — on a FAILED delete the row stays in place,
      // so its remove control must return to the trash icon.
      setLineDeleting(line, false);
    }
    setLineQuantityLoading(line, isLoading);
    lineItem.querySelectorAll(".loading-overlay").forEach(function (overlay) {
      overlay.classList.toggle("hidden", !isLoading);
    });
  }

  // Self-heal after a failed/stale update: re-fetch the drawer section
  // and re-sync the DOM with the cart's real state.
  async function recoverCartDrawerFromServer() {
    try {
      // Read the AUTHORITATIVE cart count first (no-store, so never a stale
      // cache). The section render below can be served a cached pre-add render;
      // trusting its is-empty class then wrongly blanks a non-empty drawer.
      let authoritativeCount = null;
      try {
        const cartRes = await fetch("/cart.js", {
          credentials: "same-origin",
          cache: "no-store",
          headers: { Accept: "application/json" },
        });
        if (cartRes.ok) {
          const cart = await cartRes.json();
          if (typeof cart.item_count === "number") authoritativeCount = cart.item_count;
        }
      } catch (e) {
        // Fall through — we'll fall back to the section HTML's own state.
      }

      // Fetch the drawer section render. Shopify can serve a CACHED pre-add
      // render here, which would still carry the empty-cart markup even though
      // the cart now has items. When /cart.js says the cart is non-empty but the
      // rendered drawer comes back empty, the render is stale — re-fetch with a
      // cache-busting param (and retry a couple of times) until it agrees with
      // the authoritative count, so we never paint an empty body over a real cart.
      const fetchDrawerSections = async (bust) => {
        const sep = "?";
        const url =
          window.location.pathname +
          sep +
          "sections=cart-drawer,cart-icon-bubble" +
          (bust ? "&_=" + bust : "");
        const res = await fetch(url, {
          credentials: "same-origin",
          cache: "no-store",
          headers: { Accept: "application/json" },
        });
        if (!res.ok) return null;
        return res.json();
      };

      const renderIsEmpty = (sectionHtml) => {
        if (!sectionHtml) return true;
        const doc = new DOMParser().parseFromString(sectionHtml, "text/html");
        const drawerEl = doc.querySelector("cart-drawer");
        if (drawerEl && drawerEl.classList.contains("is-empty")) return true;
        return Boolean(doc.querySelector(".drawer__inner-empty"));
      };

      const cartIsNonEmpty = authoritativeCount !== null && authoritativeCount > 0;

      let sections = await fetchDrawerSections(0);
      // Retry only when we KNOW the cart has items but the render says empty.
      let attempt = 0;
      while (
        cartIsNonEmpty &&
        renderIsEmpty(sections && sections["cart-drawer"]) &&
        attempt < 3
      ) {
        attempt += 1;
        await new Promise((resolve) => window.setTimeout(resolve, 150 * attempt));
        sections = await fetchDrawerSections(attempt * 1000 + 1);
      }

      if (!sections) return;
      const html = sections["cart-drawer"];
      if (!html) return;

      // Prefer the authoritative count; only fall back to the HTML's is-empty
      // class when /cart.js was unreachable.
      let itemCount;
      if (authoritativeCount !== null) {
        itemCount = authoritativeCount;
      } else {
        itemCount = renderIsEmpty(html) ? 0 : 1;
      }

      applyCartSectionsState({ item_count: itemCount, sections: sections });
    } catch (error) {
      // Network hiccup — leave the drawer as-is.
    }
  }

  // Exposed for assets/cart-free-gift.js: after the gift engine adds/removes a
  // gift line it re-pulls the drawer section through the same recovery path the
  // engine itself uses (authoritative /cart.js count + keyed reconcile).
  window.__cartDrawerRecover = recoverCartDrawerFromServer;
  // Fast path for the gift engine: its cart writes request sections themselves
  // (sections=cart-drawer,cart-icon-bubble), so the response HTML can be painted
  // directly — one round trip, no recovery re-fetch.
  window.__cartDrawerApplySections = applyCartSectionsState;

  async function sendLineUpdate(update) {
    setLineLoading(update.line, true);

    const payload = {
      quantity: update.quantity,
      sections: ["cart-drawer", "cart-icon-bubble"],
      sections_url: window.location.pathname,
    };
    // The line-item key survives index shifts caused by other removals;
    // fall back to the line index only for stale markup without keys.
    if (update.key) {
      payload.id = update.key;
    } else {
      payload.line = update.line;
    }

    try {
      const response = await fetch(routes.cart_change_url, {
        ...fetchConfig(),
        body: JSON.stringify(payload),
      });
      const parsedState = JSON.parse(await response.text());

      if (parsedState.errors || parsedState.status) {
        throw new Error(
          parsedState.description || parsedState.message || getGenericCartError()
        );
      }

      // Clear the protective intent for this key ONLY if the user hasn't queued
      // a newer change for it since this request left — otherwise the reconcile
      // must keep guarding the row until that newer update confirms. We compare
      // against the latest intent: if it still equals what we just sent, this
      // response is authoritative for that line and the guard can drop.
      if (update.key && pendingIntent.get(update.key) === update.quantity) {
        const mapKey = update.key;
        const hasNewerQueued =
          pendingLineUpdates.has(mapKey) || lineDebounceTimers.has(mapKey);
        if (!hasNewerQueued) pendingIntent.delete(update.key);
      }

      applyCartSectionsState(parsedState);

      // Tell the product-grid stepper (m-grid-stepper.js) to resync from
      // /cart.js. A drawer line +/-/remove changes quantities and line keys the
      // grid still holds in its cartMap; without this the grid card stays stale
      // and its next click sends a now-invalid line key, surfacing an error.
      document.dispatchEvent(
        new CustomEvent("cart:updated", { detail: { cart: parsedState } })
      );

      const drawerItems = document.querySelector("cart-drawer-items");
      if (drawerItems && typeof drawerItems.updateLiveRegions === "function") {
        try {
          drawerItems.updateLiveRegions(update.line, parsedState.item_count);
        } catch (liveRegionError) {
          // The row was removed — nothing to announce against.
        }
      }

      if (update.name && isCartDrawerOpen()) {
        const lineItem = document.getElementById("CartDrawer-Item-" + update.line);
        const focusTarget =
          lineItem && lineItem.querySelector('[name="' + update.name + '"]');
        if (focusTarget) focusTarget.focus();
      }
    } catch (error) {
      console.error("[cart-drawer] Cart update failed:", error);
      // Drop the optimistic guard for this line so recovery can restore the
      // line's TRUE server state (e.g. a failed remove must bring the row back).
      if (update.key && !lineDebounceTimers.has(update.key)) {
        pendingIntent.delete(update.key);
      }
      await recoverCartDrawerFromServer();
      // Recovery re-pulled the true server cart into the drawer; keep the grid
      // stepper in step with that same state.
      document.dispatchEvent(new CustomEvent("cart:updated", { detail: {} }));
      const errors = document.getElementById("CartDrawer-CartErrors");
      if (errors) errors.textContent = error.message || getGenericCartError();
    } finally {
      setLineLoading(update.line, false);
    }
  }

  function processLineUpdateQueue() {
    if (lineUpdateInFlight) return;
    const next = pendingLineUpdates.entries().next();
    if (next.done) {
      recomputeDrawerBusy(); // queue drained — hide loader if nothing else pending
      return;
    }

    const mapKey = next.value[0];
    const update = next.value[1];
    pendingLineUpdates.delete(mapKey);
    lineUpdateInFlight = true;
    recomputeDrawerBusy();

    sendLineUpdate(update)
      .catch(function () {})
      .then(function () {
        lineUpdateInFlight = false;
        processLineUpdateQueue();
        recomputeDrawerBusy();
      });
  }

  function queueLineUpdate(update, immediate) {
    const mapKey = update.key || "line-" + update.line;

    const existingTimer = lineDebounceTimers.get(mapKey);
    if (existingTimer) window.clearTimeout(existingTimer);

    const commit = function () {
      lineDebounceTimers.delete(mapKey);
      pendingLineUpdates.set(mapKey, update);
      processLineUpdateQueue();
    };

    if (immediate) {
      commit();
    } else {
      lineDebounceTimers.set(mapKey, window.setTimeout(commit, LINE_UPDATE_DEBOUNCE_MS));
    }
    // Show the loader the instant a change is attempted (covers the debounce
    // window too, so +/- feels acknowledged immediately).
    recomputeDrawerBusy();
  }

  if (!customElements.get("cart-drawer")) {
    class ThemeCartDrawer extends HTMLElement {
      constructor() {
        super();
        this.addEventListener("keyup", (event) => {
          if (event.code === "Escape") this.close();
        });

        bindDrawerOverlay();

        this.setHeaderCartIconAccessibility();
      }

      setHeaderCartIconAccessibility() {
        const cartLink = document.querySelector("#cart-icon-bubble");
        if (!cartLink) return;

        cartLink.setAttribute("role", "button");
        cartLink.setAttribute("aria-haspopup", "dialog");
        cartLink.addEventListener("click", (event) => {
          event.preventDefault();
          this.open(cartLink);
        });
        cartLink.addEventListener("keydown", (event) => {
          if (event.code.toUpperCase() === "SPACE") {
            event.preventDefault();
            this.open(cartLink);
          }
        });
      }

      open(triggeredBy) {
        if (this.__gridStepperRecovering) return;

        // A proactive refresh (fired by grid-stepper:cart-changed) may already be
        // in flight. Await it rather than starting a competing fetch or opening
        // over a half-updated drawer, then re-enter open() with fresh contents.
        if (window.__gridRefreshPromise && !this.__gridStepperRecovering) {
          this.__gridStepperRecovering = true;
          Promise.resolve(window.__gridRefreshPromise)
            .catch(function () {})
            .then(() => {
              this.__gridStepperRecovering = false;
              this.open(triggeredBy);
            });
          return;
        }

        if (window.__gridStepperCartDirty && !this.__gridStepperRecovering) {
          window.__gridStepperCartDirty = false;
          this.__gridStepperRecovering = true;
          Promise.resolve(recoverCartDrawerFromServer())
            .catch(function () {})
            .then(() => {
              this.__gridStepperRecovering = false;
              this.open(triggeredBy);
            });
          return;
        }

        if (triggeredBy) this.setActiveElement(triggeredBy);

        // Lazy-load steal-the-deal recommendations on first open (the rail also
        // has an IntersectionObserver, whichever fires first wins; the loader
        // is idempotent via its data-steal-recs-loaded guard).
        if (typeof window.cartDrawerLoadStealRecs === "function") {
          window.cartDrawerLoadStealRecs();
        }

        window.setTimeout(() => {
          this.classList.add("animate", "active");
        });

        this.addEventListener(
          "transitionend",
          () => {
            const containerToTrapFocusOn = this.classList.contains("is-empty")
              ? this.querySelector(".drawer__inner-empty")
              : document.getElementById("CartDrawer");
            const focusElement =
              this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");

            if (containerToTrapFocusOn && focusElement && typeof trapFocus === "function") {
              trapFocus(containerToTrapFocusOn, focusElement);
            }
          },
          { once: true }
        );

        document.body.classList.add("overflow-hidden");
      }

      close() {
        this.classList.remove("active");
        if (typeof removeTrapFocus === "function") {
          removeTrapFocus(this.activeElement);
        }
        document.body.classList.remove("overflow-hidden");

        // Bring the pill back in sync with whatever the cart looks like now.
        if (typeof window.refreshCartViewPill === "function") {
          window.refreshCartViewPill();
        }
      }

      renderContents(parsedState) {
        this.productId = parsedState.id;

        // /cart/add.js returns the added line, not the cart — after an
        // add the cart is never empty.
        applyCartSectionsState({
          item_count:
            typeof parsedState.item_count === "number" ? parsedState.item_count : 1,
          sections: parsedState.sections,
        });

        if (isNotificationEnabled()) {
          // Toast handles user feedback; drawer stays closed.
          // Toast itself is fired by the fetch/XHR success wrapper above.
        } else {
          // Original behaviour — open the cart drawer on add.
          this.open();
        }
      }

      getSectionInnerHTML(html, selector) {
        return new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(selector)
          .innerHTML;
      }

      getSectionsToRender() {
        return [
          { id: "cart-drawer", targetSelector: "#CartDrawer", renderSelector: "#CartDrawer" },
          { id: "cart-icon-bubble", targetSelector: "#cart-icon-bubble", renderSelector: "raw" },
        ];
      }

      setActiveElement(element) {
        this.activeElement = element;
      }
    }

    customElements.define("cart-drawer", ThemeCartDrawer);
  }

  if (!customElements.get("cart-drawer-items") && window.CartItems) {
    class ThemeCartDrawerItems extends window.CartItems {
      constructor() {
        super();
        // Per-line handling below replaces Dawn's single shared 300ms
        // debounce, which silently dropped the first change whenever
        // two different lines were edited within the window.
        this.addEventListener("change", (event) => {
          const target = event.target;
          if (!(target instanceof HTMLInputElement)) return;
          if (target.name !== "updates[]" || !target.dataset.index) return;
          const activeName =
            (document.activeElement && document.activeElement.getAttribute("name")) ||
            target.getAttribute("name");
          this.updateQuantity(target.dataset.index, target.value, activeName);
        });
      }

      // Reached via Dawn's shared debounce listener — neutralized; the
      // constructor listener above already queued the change per line.
      onChange() {}

      updateQuantity(line, quantity, name) {
        // Cart-wide lock guard: while any update is running, ignore every new
        // quantity/remove action (covers a stray keyboard/fast-tap that beats the
        // CSS lock). Removal flows through here as updateQuantity(line, 0), so this
        // one guard covers both quantity and delete paths.
        if (cartLocked) return;

        const parsedQuantity = parseInt(quantity, 10);
        if (!Number.isFinite(parsedQuantity) || parsedQuantity < 0) return;

        const input = document.getElementById("Drawer-quantity-" + line);
        const key = (input && input.dataset.key) || null;
        const isRemoval = parsedQuantity === 0;
        const lineItem = document.getElementById("CartDrawer-Item-" + line);

        // Record the user's intent immediately so the reconcile protects this
        // action from any stale in-flight response (see pendingIntent).
        if (key) pendingIntent.set(key, parsedQuantity);

        // Lock the whole cart the instant the action is accepted. recomputeDrawerBusy
        // (called from queueLineUpdate below) would do this too, but engaging it
        // here guarantees the very next synchronous click is already blocked.
        setCartControlsLocked(true);

        if (isRemoval) {
          // REAL-TIME DELETE: do NOT optimistically remove the row. Keep it in the
          // DOM and show a spinner on its remove control; the row is detached only
          // by the confirming reconcile (pendingIntent === 0 branch) when the
          // server response says the line is gone. On failure the row stays put.
          setLineDeleting(line, true);
          setLineLoading(line, true);
        } else {
          // OPTIMISTIC QUANTITY: reflect the new number AND the line price
          // instantly (qty × unit price), so the row total updates with no wait.
          // Exact when there are no automatic discounts; a hair approximate while
          // one applies, then reconciled by the server response a moment later.
          if (lineItem) {
            lineItem.setAttribute("data-quantity", String(parsedQuantity));
            paintOptimisticLinePrice(lineItem, parsedQuantity);
          }
          if (input) input.value = String(parsedQuantity);
          setLineQuantityLoading(line, true);
        }

        // Send immediately for BOTH paths — the cart-wide lock already prevents a
        // rapid second click, so the 300ms quantity debounce is no longer needed;
        // the only delay is the round-trip.
        queueLineUpdate(
          { key: key, line: line, quantity: parsedQuantity, name: name },
          true
        );
      }
    }

    customElements.define("cart-drawer-items", ThemeCartDrawerItems);
  }

  function getCartDrawer() {
    return document.querySelector("cart-drawer");
  }

  function isCartDrawerOpen() {
    const cartDrawer = getCartDrawer();
    return Boolean(cartDrawer && cartDrawer.classList.contains("active"));
  }

  function isManagedCustomCartForm(form) {
    if (!form) return false;
    if (form.querySelector("[data-grid-cart]")) return false;
    if (form.closest("#CartDrawer")) return true;
    if (form.closest("product-form")) return false;
    if (form.querySelector("product-form")) return false;

    return (
      form.hasAttribute("data-product-form") ||
      form.classList.contains("m_atc_main_form") ||
      form.classList.contains("prduct-filter") ||
      form.classList.contains("form_classes") ||
      form.classList.contains("mProdFilter")
    );
  }

  function setButtonLoading(button, isLoading) {
    if (!button) return;

    button.classList.toggle("loading", isLoading);
    button.toggleAttribute("aria-busy", isLoading);

    const spinner = button.querySelector(".loading-overlay__spinner");
    if (spinner) {
      spinner.classList.toggle("hidden", !isLoading);
    }
  }

  function setFbtButtonLoading(button, isLoading) {
    if (!button) return;
    if (!button.classList.contains("cart-drawer__fbt-add")) return;

    if (isLoading) {
      if (!button.dataset.originalText) {
        button.dataset.originalText = button.textContent.trim();
      }
      button.textContent = "Adding...";
      button.classList.add("is-loading");
      button.setAttribute("aria-disabled", "true");
      button.disabled = true;
      return;
    }

    button.classList.remove("is-loading");
    if (button.dataset.originalText) {
      button.textContent = button.dataset.originalText;
      delete button.dataset.originalText;
    }
    button.removeAttribute("aria-disabled");
    button.disabled = false;
  }

  function fireMilestoneConfetti() {
    if (typeof window.confetti !== "function") return;
    if (!isCartDrawerOpen()) return;

    var defaults = {
      zIndex: 2147483647,
      ticks: 350,
      gravity: 0.85,
      decay: 0.92,
      scalar: 1,
    };

    // Burst 1 — right side, angled left
    window.confetti({
      ...defaults,
      particleCount: 60,
      spread: 70,
      startVelocity: 30,
      angle: 240,
      origin: { x: 1.0, y: 0.15 },
    });

    // Burst 2 — right side, steeper angle
    window.setTimeout(function () {
      window.confetti({
        ...defaults,
        particleCount: 50,
        spread: 60,
        startVelocity: 25,
        angle: 225,
        origin: { x: 0.98, y: 0.05 },
      });
    }, 180);

    // Burst 3 — left side of drawer area
    window.setTimeout(function () {
      window.confetti({
        ...defaults,
        particleCount: 50,
        spread: 65,
        startVelocity: 28,
        angle: 300,
        origin: { x: 0.55, y: 0.1 },
      });
    }, 350);

    // Burst 4 — center rain
    window.setTimeout(function () {
      window.confetti({
        ...defaults,
        particleCount: 40,
        spread: 100,
        startVelocity: 20,
        angle: 270,
        origin: { x: 0.78, y: 0.0 },
      });
    }, 520);

    // Burst 5 — final right pop
    window.setTimeout(function () {
      window.confetti({
        ...defaults,
        particleCount: 35,
        spread: 55,
        startVelocity: 22,
        angle: 235,
        origin: { x: 1.0, y: 0.2 },
      });
    }, 680);
  }

  function readNumber(value) {
    const parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function getMilestoneStorageKey(milestoneElement) {
    const keySeed = milestoneElement?.dataset?.milestoneKey || "default";
    return `theme:cart:milestone-unlocked:${window.location.host}:${keySeed}`;
  }

  function getMilestonePopup() {
    return document.querySelector("#CartDrawer [data-milestone-popup]");
  }

  function closeMilestonePopup() {
    const popup = getMilestonePopup();
    if (!popup || popup.hidden) return false;

    popup.hidden = true;
    popup.setAttribute("aria-hidden", "true");
    popup.classList.remove("is-open");
    return true;
  }

  function openMilestonePopup(trigger) {
    const popup = getMilestonePopup();
    if (!popup) return;

    const popupText = (trigger?.dataset?.milestonePopupText || "").trim();
    if (!popupText) return;

    const titleElement = popup.querySelector("[data-milestone-popup-title]");
    const contentElement = popup.querySelector("[data-milestone-popup-content]");
    const closeButton = popup.querySelector(".cart-drawer__milestone-popup-close");

    if (titleElement) {
      titleElement.textContent = trigger.dataset.milestonePopupTitle || "";
    }

    if (contentElement) {
      contentElement.textContent = popupText;
    }

    popup.hidden = false;
    popup.setAttribute("aria-hidden", "false");
    popup.classList.add("is-open");

    if (closeButton) {
      window.setTimeout(() => closeButton.focus(), 0);
    }
  }

  // -------------------------------------------------------------
  // Coupon "View details" popup (bottom sheet on mobile / popup on desktop)
  // -------------------------------------------------------------
  function getCouponDetailsPopup() {
    return document.querySelector("#CartDrawer [data-coupon-details-popup]");
  }

  function closeCouponDetailsPopup() {
    const popup = getCouponDetailsPopup();
    if (!popup || popup.hidden) return false;

    popup.hidden = true;
    popup.setAttribute("aria-hidden", "true");
    popup.classList.remove("is-open");
    return true;
  }

  function openCouponDetailsPopup(trigger) {
    const popup = getCouponDetailsPopup();
    if (!popup) return;

    // The richtext body lives in a hidden sibling div (HTML can't ride in an
    // attribute); clone its markup into the shared popup body.
    const sourceId = trigger.getAttribute("data-coupon-details-id");
    const source = sourceId ? document.getElementById(sourceId) : null;
    if (!source) return;

    const titleElement = popup.querySelector("[data-coupon-details-title]");
    const bodyElement = popup.querySelector("[data-coupon-details-body]");
    const codeLine = popup.querySelector("[data-coupon-details-code-line]");
    const codeValue = popup.querySelector("[data-coupon-details-code]");
    const savingsElement = popup.querySelector("[data-coupon-details-savings]");
    const copyButton = popup.querySelector("[data-coupon-details-copy]");
    const footerElement = popup.querySelector("[data-coupon-details-footer]");
    const termsElement = popup.querySelector("[data-coupon-details-terms]");
    const closeButton = popup.querySelector(".cart-drawer__coupon-details-close");

    if (titleElement) {
      titleElement.textContent = trigger.dataset.couponDetailsTitle || "";
    }
    if (bodyElement) {
      bodyElement.innerHTML = source.innerHTML;
    }

    // Code line (e.g. "B2G4") — shown on its own row for copyable code coupons.
    const code = (trigger.dataset.couponDetailsCode || "").trim();
    if (codeValue) codeValue.textContent = code;
    if (codeLine) codeLine.hidden = !code;
    // The Copy button stores the code it copies; hidden when there's no code.
    if (copyButton) {
      copyButton.dataset.couponCode = code;
      copyButton.hidden = !code;
    }

    // Savings line ("Save ₹X with this offer") on the left of the footer.
    const savings = (trigger.dataset.couponDetailsSavings || "").trim();
    if (savingsElement) {
      savingsElement.textContent = savings;
      savingsElement.hidden = !savings;
    }
    // Hide the whole footer (and its divider) when there's neither savings
    // nor a copyable code to show.
    if (footerElement) {
      footerElement.hidden = !savings && !code;
    }

    // Terms / checkmark lines — cloned from the per-coupon hidden source.
    if (termsElement) {
      const termsSource = sourceId ? document.getElementById(sourceId + "-terms") : null;
      if (termsSource && termsSource.innerHTML.trim()) {
        termsElement.innerHTML = termsSource.innerHTML;
        termsElement.hidden = false;
      } else {
        termsElement.innerHTML = "";
        termsElement.hidden = true;
      }
    }

    popup.hidden = false;
    popup.setAttribute("aria-hidden", "false");
    popup.classList.add("is-open");

    if (closeButton) {
      window.setTimeout(() => closeButton.focus(), 0);
    }
  }

  function checkMilestoneCelebration() {
    if (!isCartDrawerOpen()) {
      closeMilestonePopup();
      closeCouponDetailsPopup();
      return;
    }

    const milestoneElement = document.querySelector(
      "#CartDrawer .cart-drawer__milestone[data-milestone-unlocked]"
    );
    if (!milestoneElement) return;

    const unlocked = readNumber(milestoneElement.dataset.milestoneUnlocked);
    const storageKey = getMilestoneStorageKey(milestoneElement);

    let previousUnlocked = 0;
    try {
      previousUnlocked = readNumber(window.localStorage.getItem(storageKey));
    } catch (error) {
      previousUnlocked = 0;
    }

    if (unlocked > 0 && unlocked > previousUnlocked) {
      fireMilestoneConfetti();
    }

    try {
      window.localStorage.setItem(storageKey, String(unlocked));
    } catch (error) {
      // Ignore storage failures.
    }
  }

  // Single shared observer + debounce timer, re-armed (not duplicated) on each
  // section swap so it never accumulates listeners on the persistent host.
  let milestoneObserver = null;
  let milestoneDebounceTimer = null;

  function queueMilestoneCheck() {
    window.clearTimeout(milestoneDebounceTimer);
    milestoneDebounceTimer = window.setTimeout(checkMilestoneCelebration, 80);
  }

  function setupMilestoneObserver() {
    const cartDrawer = getCartDrawer();
    const drawerRoot = document.getElementById("CartDrawer");
    if ((!cartDrawer && !drawerRoot) || typeof MutationObserver === "undefined") {
      checkMilestoneCelebration();
      return;
    }

    // Tear down the previous observer first — section swaps replace the milestone
    // node, so a fresh observe() is needed, but without disconnecting we'd stack
    // a new observer on the persistent host on every cart mutation.
    if (milestoneObserver) milestoneObserver.disconnect();
    milestoneObserver = new MutationObserver(queueMilestoneCheck);

    // Observe ONLY the milestone block (its data-milestone-unlocked attribute is
    // all checkMilestoneCelebration reads), not the whole #CartDrawer subtree.
    // A subtree observer woke up on every line-item / footer / steal swap —
    // dozens of needless 80ms debounce + localStorage reads per cart mutation.
    const milestoneBlock = drawerRoot
      ? drawerRoot.querySelector(".cart-drawer__milestone")
      : null;
    if (milestoneBlock) {
      milestoneObserver.observe(milestoneBlock, {
        attributes: true,
        attributeFilter: ["data-milestone-unlocked"],
      });
    }

    // The drawer opening/closing (its .active class) is what gates the popup, so
    // keep that lightweight class-only observer on the host element.
    if (cartDrawer) {
      milestoneObserver.observe(cartDrawer, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }

    queueMilestoneCheck();
  }

  function getCartAddUrl() {
    return (window.routes && window.routes.cart_add_url) || "/cart/add";
  }

  function getCartUrl() {
    return (window.routes && window.routes.cart_url) || "/cart";
  }

  function getGenericCartError() {
    return (
      (window.cartStrings && window.cartStrings.error) ||
      "Sorry, we couldn't add this item. Please try again."
    );
  }

  function getProductJsonUrl() {
    const canonical = document.querySelector('link[rel="canonical"]');
    const path = canonical
      ? new URL(canonical.href, window.location.origin).pathname
      : window.location.pathname;

    return path.replace(/\/$/, "") + ".js";
  }

  async function resolveCartFormVariantId(form, formData) {
    const existingId = formData.get("id");
    if (existingId) return String(existingId);

    const field =
      form.querySelector(".m_product_varaint_input") ||
      form.querySelector('input[name="id"]:checked') ||
      form.querySelector('select[name="id"]') ||
      form.querySelector('input[name="id"]');

    if (field && field.value) {
      formData.set("id", field.value);
      return String(field.value);
    }

    const activeSibling = document.querySelector(
      ".m-sibling-selector--pdp .m-sibling-pill.is-active"
    );
    if (activeSibling && activeSibling.dataset.productVariantId) {
      formData.set("id", activeSibling.dataset.productVariantId);
      return String(activeSibling.dataset.productVariantId);
    }

    if (pendingAtcVariantId) {
      formData.set("id", String(pendingAtcVariantId));
      return String(pendingAtcVariantId);
    }

    try {
      const response = await fetch(getProductJsonUrl(), {
        method: "GET",
        credentials: "same-origin",
        cache: "no-store",
        headers: { Accept: "application/json" },
      });

      if (!response.ok) return null;

      const productJson = await response.json();
      const variants = productJson && productJson.variants ? productJson.variants : [];
      const variant = variants.find((item) => item.available) || variants[0];

      if (!variant || !variant.id) return null;

      formData.set("id", String(variant.id));
      console.log("[cart-drawer] Resolved missing ATC variant from product JSON", variant);
      return String(variant.id);
    } catch (error) {
      console.error("[cart-drawer] Could not resolve missing ATC variant", error);
      return null;
    }
  }

  async function postCartAdd(formData) {
    const response = await fetch(getCartAddUrl(), {
      method: "POST",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: formData,
    });

    const rawText = await response.text();
    let payload = null;
    try {
      payload = rawText ? JSON.parse(rawText) : null;
    } catch (parseError) {
      payload = null;
    }

    if (!payload) {
      const message = response.ok
        ? getGenericCartError()
        : `${getGenericCartError()} (HTTP ${response.status})`;
      const err = new Error(message);
      err.httpStatus = response.status;
      err.rawBody = rawText;
      throw err;
    }

    if (payload.status || payload.errors) {
      throw new Error(
        payload.description || payload.message || getGenericCartError()
      );
    }

    return payload;
  }

  function applyCartDrawerPayload(cartDrawer, payload) {
    if (!cartDrawer) {
      window.location.href = getCartUrl();
      return;
    }

    cartDrawer.renderContents(payload);
    cartDrawer.classList.remove("is-empty");
    const innerPanel = cartDrawer.querySelector(".drawer__inner");
    if (innerPanel) {
      innerPanel.classList.remove("is-empty");
    }
    window.setTimeout(checkMilestoneCelebration, 120);
  }

  async function submitCartForm(form) {
    const cartDrawer = getCartDrawer();
    const formData = new FormData(form);
    const variantId = await resolveCartFormVariantId(form, formData);

    if (!variantId) {
      throw new Error("Missing product variant id. Please refresh and try again.");
    }

    if (cartDrawer) {
      formData.append(
        "sections",
        cartDrawer.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
      cartDrawer.setActiveElement(document.activeElement);
    }

    const payload = await postCartAdd(formData);
    applyCartDrawerPayload(cartDrawer, payload);

    document.dispatchEvent(
      new CustomEvent("theme:cart:added", {
        detail: payload,
      })
    );
  }

  async function submitFbtVariant(variantId, quantity) {
    const cartDrawer = getCartDrawer();
    const formData = new FormData();

    formData.append("id", String(variantId));
    formData.append("quantity", String(quantity || 1));

    if (cartDrawer) {
      formData.append(
        "sections",
        cartDrawer.getSectionsToRender().map((section) => section.id)
      );
      formData.append("sections_url", window.location.pathname);
      cartDrawer.setActiveElement(document.activeElement);
    }

    const payload = await postCartAdd(formData);
    applyCartDrawerPayload(cartDrawer, payload);
  }

  function updateFbtCardFromVariantSelect(select) {
    if (!(select instanceof HTMLSelectElement)) return;

    const card = select.closest(".cart-drawer__fbt-card");
    if (!card) return;

    const selectedOption = select.options[select.selectedIndex];
    if (!selectedOption) return;

    const button = card.querySelector(".cart-drawer__fbt-add[data-fbt-variant-id]");
    const priceEl = card.querySelector("[data-fbt-price]");
    const compareEl = card.querySelector("[data-fbt-compare]");

    const variantId = selectedOption.value;
    const priceCents = parseInt(selectedOption.dataset.priceCents || "0", 10) || 0;
    const compareCents = parseInt(selectedOption.dataset.compareCents || "0", 10) || 0;
    const available = selectedOption.dataset.available === "true";
    const inCart = selectedOption.dataset.inCart === "true";
    const onSale = compareCents > priceCents;

    if (priceEl) {
      priceEl.textContent = formatMoneyValue(priceCents);
    }

    if (compareEl) {
      compareEl.textContent = onSale ? formatMoneyValue(compareCents) : "";
      compareEl.classList.toggle("hidden", !onSale);
    }

    // Image % OFF badge — keep it in step with the chosen variant. The server
    // only renders it when the DEFAULT variant is on sale, so it may be absent;
    // create it on the image link when the newly-selected variant is on sale,
    // and remove it otherwise so a stale discount never lingers.
    const imgLink = card.querySelector(".cart-drawer__steal-img");
    let tagEl = card.querySelector(".cart-drawer__steal-tag");
    if (onSale) {
      const pct = Math.round(((compareCents - priceCents) * 100) / compareCents);
      if (!tagEl && imgLink) {
        tagEl = document.createElement("span");
        tagEl.className = "cart-drawer__steal-tag";
        imgLink.appendChild(tagEl);
      }
      if (tagEl) tagEl.textContent = pct + "% OFF";
    } else if (tagEl) {
      tagEl.remove();
    }

    if (!button) return;

    button.dataset.fbtVariantId = variantId;
    button.classList.remove("cart-drawer__fbt-add--added", "cart-drawer__fbt-add--disabled");

    if (inCart) {
      button.textContent = "Added ✓";
      button.classList.add("cart-drawer__fbt-add--added");
      button.disabled = true;
      return;
    }

    if (!available) {
      button.textContent = "Sold out";
      button.classList.add("cart-drawer__fbt-add--disabled");
      button.disabled = true;
      return;
    }

    button.textContent = "Add +";
    button.disabled = false;
  }

  // Flip a steal/FBT card's Add button to the "Added ✓" state after the variant
  // it points at has been added to the cart. The rail is preserved across the
  // section swap (see swapStealRail), so the server render never refreshes this
  // button within the same drawer session — we update it client-side here, the
  // same way updateFbtCardFromVariantSelect does for an already-in-cart variant.
  function markFbtButtonAdded(button) {
    if (!button) return;
    const variantId = button.dataset.fbtVariantId;

    // Keep the matching <option data-in-cart> in sync so re-selecting that
    // variant continues to show "Added ✓" rather than reverting to "Add +".
    const card = button.closest(".cart-drawer__fbt-card");
    const select = card && card.querySelector("[data-fbt-variant-select]");
    if (select && variantId) {
      const opt = Array.prototype.find.call(select.options, function (o) {
        return o.value === String(variantId);
      });
      if (opt) opt.dataset.inCart = "true";
    }

    // setFbtButtonLoading stores/restores originalText; clear it so the restore
    // in the finally block can't stomp the "Added" label we set here.
    delete button.dataset.originalText;
    button.classList.remove("cart-drawer__fbt-add--disabled");
    button.classList.add("cart-drawer__fbt-add--added");
    button.textContent = "Added ✓";
    button.disabled = true;
  }

  function formatMoneyValue(cents) {
    const amount = (Number(cents) || 0) / 100;
    const currencyCode =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "INR";

    try {
      const formatted = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: currencyCode,
        maximumFractionDigits: 0,
      }).format(amount);
      return formatted.replace(/\u00A0/g, " ");
    } catch (error) {
      return `\u20B9${Math.round(amount)}`;
    }
  }

  document.addEventListener(
    "submit",
    async function (event) {
      const form = event.target;

      if (!(form instanceof HTMLFormElement)) return;
      const isFbtForm = form.classList.contains("cart-drawer__fbt-form");

      if (!isFbtForm) {
        const action = form.getAttribute("action") || "";
        if (!action.includes("/cart/add")) return;
        if (!isManagedCustomCartForm(form)) return;
      }

      if (form.dataset.cartDrawerSubmitting === "true") {
        event.preventDefault();
        return;
      }

      event.preventDefault();
      form.dataset.cartDrawerSubmitting = "true";

      const submitButton =
        form.querySelector('[type="submit"][name="add"]') ||
        form.querySelector(".add-cart-btn") ||
        form.querySelector('[type="submit"]');

      try {
        setButtonLoading(submitButton, true);
        if (isFbtForm) {
          setFbtButtonLoading(submitButton, true);
        }
        if (submitButton) submitButton.setAttribute("aria-disabled", "true");
        await submitCartForm(form);
      } catch (error) {
        console.error("[cart-drawer] Add to cart failed:", error);
        if (error && error.rawBody) {
          console.error(
            "[cart-drawer] Server response (first 500 chars):",
            String(error.rawBody).slice(0, 500)
          );
        }
        window.alert(error.message || getGenericCartError());
      } finally {
        setButtonLoading(submitButton, false);
        if (isFbtForm) {
          setFbtButtonLoading(submitButton, false);
        }
        if (submitButton) submitButton.removeAttribute("aria-disabled");
        delete form.dataset.cartDrawerSubmitting;
      }
    },
    true
  );

  document.addEventListener(
    "click",
    async function (event) {
      const button = event.target.closest(".cart-drawer__fbt-add[data-fbt-variant-id]");
      if (!button) return;
      if (button.disabled) {
        event.preventDefault();
        return;
      }

      const variantId = button.dataset.fbtVariantId;
      const quantity = parseInt(button.dataset.fbtQuantity || "1", 10) || 1;
      if (!variantId) return;

      if (button.dataset.cartDrawerSubmitting === "true") {
        event.preventDefault();
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      button.dataset.cartDrawerSubmitting = "true";

      let added = false;
      try {
        setFbtButtonLoading(button, true);
        await submitFbtVariant(variantId, quantity);
        added = true;
      } catch (error) {
        console.error("[cart-drawer] FBT add failed:", error);
        if (error && error.rawBody) {
          console.error(
            "[cart-drawer] Server response (first 500 chars):",
            String(error.rawBody).slice(0, 500)
          );
        }
        window.alert(error.message || getGenericCartError());
      } finally {
        setFbtButtonLoading(button, false);
        delete button.dataset.cartDrawerSubmitting;
        // On success flip to "Added ✓" — the preserved rail won't get a server
        // refresh this session, so the button state is updated client-side.
        if (added) markFbtButtonAdded(button);
      }
    },
    true
  );

  document.addEventListener(
    "change",
    function (event) {
      const select = event.target.closest("[data-fbt-variant-select]");
      if (!select) return;
      event.stopImmediatePropagation();
      updateFbtCardFromVariantSelect(select);
    },
    true
  );

  document.addEventListener("click", function (event) {
    const popupTrigger = event.target.closest("[data-milestone-popup-trigger]");
    if (popupTrigger) {
      event.preventDefault();
      event.stopPropagation();
      openMilestonePopup(popupTrigger);
      return;
    }

    const couponTrigger = event.target.closest("[data-coupon-details-trigger]");
    if (couponTrigger) {
      event.preventDefault();
      // stopImmediatePropagation (not just stopPropagation) so the separate
      // copy-to-clipboard listener on document doesn't also fire for this click.
      event.stopImmediatePropagation();
      openCouponDetailsPopup(couponTrigger);
      return;
    }

    const couponCopy = event.target.closest("[data-coupon-details-copy]");
    if (couponCopy) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const code = (couponCopy.dataset.couponCode || "").trim();
      if (code) copyCouponCode(code, couponCopy);
      return;
    }

    const couponClose = event.target.closest("[data-coupon-details-close]");
    if (couponClose) {
      event.preventDefault();
      closeCouponDetailsPopup();
      return;
    }

    const popupClose = event.target.closest("[data-milestone-popup-close]");
    if (!popupClose) return;

    event.preventDefault();
    closeMilestonePopup();
  });

  document.addEventListener(
    "keyup",
    function (event) {
      if (event.code !== "Escape") return;
      const closed = closeCouponDetailsPopup() || closeMilestonePopup();
      if (!closed) return;

      event.preventDefault();
      event.stopPropagation();
    },
    true
  );

  document.addEventListener("click", function (event) {
    const trigger = event.target.closest("[data-cart-open]");
    if (!trigger) return;

    const cartDrawer = getCartDrawer();
    if (!cartDrawer) return;

    event.preventDefault();
    cartDrawer.open(trigger);
  });

  // App-rendered mobile menu: open cart drawer instead of navigating to /cart
  document.addEventListener("click", function (event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (event.button !== undefined && event.button !== 0) return;

    const cartLink = event.target.closest(".m-icon-main a");
    if (!cartLink) return;
    if (cartLink.pathname !== "/cart") return;

    const cartDrawer = getCartDrawer();
    if (!cartDrawer) return;

    event.preventDefault();
    cartDrawer.open(cartLink);
  });

  document.addEventListener("DOMContentLoaded", setupMilestoneObserver);

  // -------------------------------------------------------------
  // In-drawer toast (mockup #CartDrawer-Toast) — copy / add confirmations
  // -------------------------------------------------------------
  let drawerToastTimer = null;
  function showDrawerToast(message) {
    const toast = document.getElementById("CartDrawer-Toast");
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add("is-visible");
    if (drawerToastTimer) window.clearTimeout(drawerToastTimer);
    drawerToastTimer = window.setTimeout(function () {
      toast.classList.remove("is-visible");
      drawerToastTimer = null;
    }, 1700);
  }

  // -------------------------------------------------------------
  // Coupon copy-to-clipboard ( [data-coupon-copy="CODE"] )
  // -------------------------------------------------------------
  // Shared clipboard write + "copied" feedback. Used by the coupon row
  // ([data-coupon-copy]) and the details-popup copy button.
  async function copyCouponCode(code, button) {
    if (!code) return;

    try {
      await navigator.clipboard.writeText(code);
    } catch (e) {
      const ta = document.createElement("textarea");
      ta.value = code;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand("copy");
      } catch (copyErr) {
        // ignore
      }
      ta.remove();
    }

    if (button) {
      button.classList.add("is-copied");
      window.setTimeout(function () {
        button.classList.remove("is-copied");
      }, 1500);
    }
    // No "Code … copied" toast — the is-copied state above is the feedback.
  }

  function copyCouponFrom(button, target) {
    // Coupon cards copy ONLY from their copy icon. Tapping elsewhere on a
    // qualifying card PICKS it for the total; on any other card it does
    // nothing. The best-deal bar (not a card) still copies on tap.
    const onCopyIcon = !!(target && target.closest && target.closest(".cart-drawer__coupon-copy"));
    if (button.classList.contains("cart-drawer__coupon") && !onCopyIcon) {
      if (button.hasAttribute("data-coupon-select")) {
        writeCouponPick(button.getAttribute("data-coupon-select"));
        renderCouponPick(button);
        applyWalletToTotal();
      }
      return;
    }
    const code = button.getAttribute("data-coupon-copy");
    copyCouponCode(code, button);
  }

  // -------------------------------------------------------------
  // Shopper coupon pick ( [data-coupon-select="CODE"] )
  // -------------------------------------------------------------
  // By default the footer shows the auto-picked best coupon (Liquid). Tapping
  // another QUALIFYING coupon card previews that one instead: highlight, best-
  // deal bar, coupon summary row, Estimated Total, struck price and (i) tip.
  // Display only — nothing is written to the cart. Liquid pre-renders every
  // figure on the card (data-sel-*), so this only swaps text. The pick lives in
  // sessionStorage and is re-applied after each drawer re-render while that
  // coupon still qualifies; otherwise the server's auto best stands.
  const COUPON_PICK_KEY = "biotique:couponPick";

  function readCouponPick() {
    try {
      return window.sessionStorage.getItem(COUPON_PICK_KEY) || "";
    } catch (e) {
      return "";
    }
  }

  function writeCouponPick(code) {
    try {
      if (code) {
        window.sessionStorage.setItem(COUPON_PICK_KEY, code);
      } else {
        window.sessionStorage.removeItem(COUPON_PICK_KEY);
      }
    } catch (e) {
      // storage blocked — the pick simply won't survive a re-render
    }
  }

  function renderCouponPick(card) {
    const drawer = document.getElementById("CartDrawer");
    if (!drawer || !card) return;
    const code = card.getAttribute("data-coupon-select");
    const data = card.dataset;

    drawer.querySelectorAll(".cart-drawer__coupon--best").forEach(function (el) {
      el.classList.remove("cart-drawer__coupon--best");
    });
    card.classList.add("cart-drawer__coupon--best");

    const bar = drawer.querySelector(".cart-drawer__best-deal-bar");
    if (bar) {
      bar.setAttribute("data-coupon-copy", code);
      bar.setAttribute("aria-label", "Copy code " + code);
      const barText = bar.querySelector(".cart-drawer__best-deal-text");
      if (barText) barText.innerHTML = data.selBar || "";
    }

    // No coupon row = the effective-price setting is off, so the total is
    // not coupon-based and must stay as rendered.
    const row = drawer.querySelector(".cart-drawer__summary-row--coupon");
    if (!row) return;
    const label = row.querySelector("[data-coupon-summary-label]");
    if (label) label.textContent = data.selLabel || "";
    const rowCode = row.querySelector(".cart-drawer__summary-coupon-code");
    if (rowCode) rowCode.textContent = code;
    // Money strings come from Liquid's money filter, which on this store wraps
    // the figure in <span class=money> — so they are set as HTML, not text.
    const amount = row.querySelector("[data-coupon-summary-amount]");
    if (amount) amount.innerHTML = data.selAmount || "";

    const total = drawer.querySelector(".cart-drawer__total-final");
    // Skip when this render already shows the pick: fillWalletNote re-runs on
    // timers, and rewriting here would drop a wallet deduction it then skips.
    if (total && data.selTotal && total.dataset.couponPick !== code) {
      total.innerHTML = data.selTotal;
      total.dataset.couponPick = code;
      // Wallet math starts from this figure (see applyWalletToTotal).
      total.dataset.walletBase = total.textContent.trim();
    }

    const wrap = drawer.querySelector(".cart-drawer__total-value-wrap");
    if (wrap) {
      let strike = wrap.querySelector(".cart-drawer__total-mrp");
      if (data.selStrike) {
        if (!strike) {
          strike = document.createElement("s");
          strike.className = "cart-drawer__total-mrp";
          wrap.insertBefore(strike, wrap.firstChild);
        }
        strike.innerHTML = data.selStrike;
      } else if (strike) {
        strike.remove();
      }
    }

    const tip = drawer.querySelector(".cart-drawer__total-info");
    if (tip && data.selTip) {
      tip.setAttribute("data-summary-tip", data.selTip);
      tip.setAttribute("aria-label", data.selTip);
    }
  }

  // Re-apply the stored pick to a fresh render. Called from fillWalletNote(),
  // which already runs after every drawer re-render, so the pick lands before
  // the wallet adjusts the total.
  function applyCouponPick() {
    const code = readCouponPick();
    if (!code) return;
    const drawer = document.getElementById("CartDrawer");
    if (!drawer) return;
    const card = Array.prototype.find.call(
      drawer.querySelectorAll("[data-coupon-select]"),
      function (el) {
        return el.getAttribute("data-coupon-select") === code;
      }
    );
    if (card) {
      renderCouponPick(card);
    } else if (drawer.querySelector(".cart-drawer__coupon-rail")) {
      // The picked coupon no longer qualifies — fall back to the auto best.
      writeCouponPick("");
    }
  }

  // Keyboard activation for the role="button" coupon row.
  document.addEventListener("keydown", function (event) {
    if (event.key !== "Enter" && event.key !== " " && event.key !== "Spacebar") return;
    const button = event.target.closest("[data-coupon-copy]");
    if (!button) return;
    event.preventDefault();
    copyCouponFrom(button, event.target);
  });

  document.addEventListener("click", function (event) {
    const button = event.target.closest("[data-coupon-copy]");
    if (!button) return;
    event.preventDefault();
    copyCouponFrom(button, event.target);
  });

  // -------------------------------------------------------------
  // Steal-the-deal collapse toggle
  // -------------------------------------------------------------
  document.addEventListener("click", function (event) {
    const toggle = event.target.closest(".cart-drawer__steal-toggle");
    if (!toggle) return;
    const steal = toggle.closest(".cart-drawer__steal");
    if (!steal) return;
    const collapsed = steal.classList.toggle("is-collapsed");
    toggle.setAttribute("aria-expanded", String(!collapsed));
  });

  function activateStealTab(steal, target) {
    if (!steal || !target) return;
    const tabs = steal.querySelectorAll("[data-steal-tab]");
    const panels = steal.querySelectorAll("[data-steal-panel]");
    tabs.forEach(function (tab) {
      const isActive = tab.getAttribute("data-steal-tab-target") === target;
      tab.setAttribute("aria-selected", String(isActive));
      tab.tabIndex = isActive ? 0 : -1;
    });
    panels.forEach(function (panel) {
      const isActive = panel.getAttribute("data-steal-panel") === target;
      panel.classList.toggle("is-active", isActive);
      panel.hidden = !isActive;
    });
  }

  document.addEventListener("click", function (event) {
    const tab = event.target.closest("[data-steal-tab]");
    if (!tab) return;
    const steal = tab.closest(".cart-drawer__steal");
    if (!steal) return;
    event.preventDefault();
    activateStealTab(steal, tab.getAttribute("data-steal-tab-target"));
  });

  // -------------------------------------------------------------
  // Lazy "Steal the deal" recommendations
  // -------------------------------------------------------------
  // The collection-driven cards render server-side. When the merchant also
  // enables Shopify recommendations, the rail carries data-steal-recs-url. We
  // fetch that ONCE (on first drawer open OR when the rail scrolls into view),
  // dedupe recs against the variant ids already in the rail, append the new
  // cards, and stamp data-steal-recs-loaded so the section swap won't wipe them.
  let stealRecsObserver = null;

  function getStealRail() {
    return document.querySelector("#CartDrawer [data-steal-rail]");
  }

  function railVariantIds(rail) {
    const ids = new Set();
    rail.querySelectorAll("[data-fbt-variant-id]").forEach(function (btn) {
      const v = btn.getAttribute("data-fbt-variant-id");
      if (v) ids.add(String(v));
    });
    return ids;
  }

  async function loadStealRecommendations() {
    const rail = getStealRail();
    if (!rail) return;
    if (rail.dataset.stealRecsLoaded === "true" || rail.dataset.stealRecsLoading === "true") return;
    const baseUrl = rail.getAttribute("data-steal-recs-url");
    if (!baseUrl) return;

    // Anchor recommendations on the first product in the cart.
    let productId = null;
    try {
      const cartRes = await fetch("/cart.js", {
        headers: { Accept: "application/json" },
        credentials: "same-origin",
      });
      const cart = await cartRes.json();
      if (cart && cart.items && cart.items.length) {
        productId = cart.items[0].product_id;
      }
    } catch (e) {
      // fall through — without a product id the API returns nothing useful
    }
    if (!productId) return;

    rail.dataset.stealRecsLoading = "true";
    const max = parseInt(rail.getAttribute("data-steal-max") || "8", 10) || 8;
    const url = baseUrl + "&product_id=" + encodeURIComponent(productId);

    try {
      const response = await fetch(url, {
        credentials: "same-origin",
        headers: { Accept: "text/html" },
      });
      if (!response.ok) return;
      const text = await response.text();
      const parsed = new DOMParser().parseFromString(text, "text/html");
      const result =
        parsed.querySelector("[data-steal-recs-result]") ||
        parsed.getElementById("CartDrawer-StealRecs");
      if (!result) return;

      // The recs section is fetched standalone and can't read the cart-drawer's
      // "Show variant dropdown" setting, so its cards always render the dropdown.
      // Honour the merchant setting here by stripping it when the rail says off.
      const hideVariants = rail.getAttribute("data-steal-show-variants") === "false";

      const existing = railVariantIds(rail);
      const cards = Array.from(result.querySelectorAll(".cart-drawer__steal-card"));
      let appended = 0;
      cards.forEach(function (card) {
        if (rail.children.length >= max) return;
        const btn = card.querySelector("[data-fbt-variant-id]");
        const v = btn && btn.getAttribute("data-fbt-variant-id");
        if (v && existing.has(String(v))) return; // dedupe vs collection cards
        if (v) existing.add(String(v));
        if (hideVariants) {
          const sel = card.querySelector("[data-fbt-variant-select]");
          if (sel) sel.remove();
        }
        rail.appendChild(card);
        appended += 1;
      });

      rail.dataset.stealRecsLoaded = "true";
      if (appended === 0 && rail.children.length === 0) {
        // Nothing to show at all — hide the empty steal section.
        const steal = rail.closest(".cart-drawer__steal");
        if (steal) steal.hidden = true;
      }
    } catch (e) {
      // Network hiccup — leave the collection cards as-is.
    } finally {
      delete rail.dataset.stealRecsLoading;
    }
  }

  function observeStealRail() {
    const rail = getStealRail();
    if (!rail || !rail.getAttribute("data-steal-recs-url")) return;
    if (rail.dataset.stealRecsLoaded === "true") return;
    if (typeof IntersectionObserver === "undefined") {
      loadStealRecommendations();
      return;
    }
    if (stealRecsObserver) stealRecsObserver.disconnect();
    stealRecsObserver = new IntersectionObserver(
      function (entries, observer) {
        if (!entries[0] || !entries[0].isIntersecting) return;
        observer.disconnect();
        loadStealRecommendations();
      },
      { rootMargin: "0px 0px 200px 0px" }
    );
    stealRecsObserver.observe(rail);
  }

  // Expose so the drawer's open() can trigger the lazy load on first open too.
  window.cartDrawerLoadStealRecs = loadStealRecommendations;

  document.addEventListener("DOMContentLoaded", observeStealRail);
  // Re-arm after a section re-render replaces the rail (e.g. add/remove item).
  document.addEventListener("theme:cart:added", function () {
    window.setTimeout(observeStealRail, 200);
  });


  // -------------------------------------------------------------
  // Wallet row (under the coupon rail)
  //
  // Liquid renders the eligibility line filled in whenever it can read the
  // customer's wallet metafield; where it can't, the row arrives hidden and
  // empty and we fall back to the HEADER WALLET PILL (.m_cashback_button) —
  // the one place on this store the balance is known to render. Nothing to
  // read anywhere → the row stays hidden.
  //
  // Ticking the box reflects the wallet amount in the Estimated Total. This is
  // a DISPLAY adjustment: the actual redemption is settled by the wallet app,
  // so nothing is posted to /cart from here.
  // -------------------------------------------------------------
  const WALLET_APPLIED_KEY = "biotique:walletApplied";

  function readWalletNumber(text) {
    if (!text) return null;
    // "₹1,234.50" → 1234.5
    const match = String(text).replace(/[\s,]/g, "").match(/\d+(?:\.\d+)?/);
    if (!match) return null;
    const value = parseFloat(match[0]);
    return isFinite(value) ? value : null;
  }

  function readWalletSymbol(text) {
    const match = String(text || "").trim().match(/^[^\d]+/);
    return (match ? match[0].trim() : "") || "₹";
  }

  function formatWalletAmount(symbol, amount) {
    const rounded = Math.round(amount * 100) / 100;
    return symbol + (rounded % 1 === 0 ? String(rounded) : rounded.toFixed(2));
  }

  function isWalletApplied() {
    try {
      return window.sessionStorage.getItem(WALLET_APPLIED_KEY) === "1";
    } catch (error) {
      return false;
    }
  }

  function setWalletApplied(applied) {
    try {
      window.sessionStorage.setItem(WALLET_APPLIED_KEY, applied ? "1" : "0");
    } catch (error) {
      /* private mode — the toggle still works for this render */
    }
  }

  function getWalletNote() {
    return document.querySelector("#CartDrawer [data-wallet-note]");
  }

  // How much this cart can actually take off — stashed on the row by
  // fillWalletNote so the total math doesn't have to re-parse the sentence.
  function getWalletUsable(note) {
    return readWalletNumber(note.dataset.walletUsable) || 0;
  }

  // The matching "Wallet" line in the Order Summary breakdown. It is a hidden
  // shell in the markup (Liquid cannot know the shopper ticked the box), so it
  // is filled here in the same pass as the total — one place, no drift. Absent
  // entirely when the merchant turned the row off.
  function renderWalletSummaryRow(symbol, usable) {
    const row = document.querySelector("#CartDrawer [data-wallet-summary-row]");
    if (!row) return;
    const amount = row.querySelector("[data-wallet-summary-amount]");
    if (usable > 0) {
      if (amount) amount.textContent = "- " + formatWalletAmount(symbol, usable);
      row.hidden = false;
    } else {
      if (amount) amount.textContent = "";
      row.hidden = true;
    }
  }

  function applyWalletToTotal() {
    const note = getWalletNote();
    const totalElement = document.querySelector(
      "#CartDrawer .cart-drawer__total-final"
    );
    if (!totalElement) {
      renderWalletSummaryRow("", 0);
      return;
    }

    // Remember the untouched total ONCE per render, so unticking can restore it
    // exactly (including any coupon-adjusted price already shown here).
    if (!totalElement.dataset.walletBase) {
      totalElement.dataset.walletBase = totalElement.textContent.trim();
    }
    const baseText = totalElement.dataset.walletBase;

    // Clear any struck total left by an older build of this script.
    const staleWas = totalElement.parentElement
      ? totalElement.parentElement.querySelector(".cart-drawer__total-wallet-was")
      : null;
    if (staleWas) staleWas.remove();

    const applied = !!note && !note.hidden && isWalletApplied();
    if (note) note.classList.toggle("is-applied", applied);

    if (!applied) {
      totalElement.textContent = baseText;
      renderWalletSummaryRow("", 0);
      return;
    }

    const base = readWalletNumber(baseText);
    const usable = getWalletUsable(note);
    if (base === null || usable <= 0) {
      totalElement.textContent = baseText;
      renderWalletSummaryRow("", 0);
      return;
    }

    const symbol = readWalletSymbol(baseText);
    const next = Math.max(0, base - usable);
    totalElement.textContent = formatWalletAmount(symbol, next);
    renderWalletSummaryRow(symbol, usable);

    // No extra <s> here. The total row already renders the pre-discount MRP as
    // .cart-drawer__total-mrp, so adding one struck the price twice ("MRP,
    // pre-wallet, payable"). The wallet amount is shown on its own summary row
    // instead, which is where the breakdown belongs.
  }

  function fillWalletNote() {
    applyCouponPick();
    const note = getWalletNote();
    if (!note) return;

    const text = note.querySelector("[data-wallet-note-txt]");
    if (!text) return;

    // Liquid could read the balance — reuse the amounts it already printed.
    if (text.textContent.trim()) {
      const amounts = text.querySelectorAll("strong");
      if (amounts.length) {
        note.dataset.walletUsable = String(
          readWalletNumber(amounts[0].textContent) || 0
        );
      }
      note.hidden = false;
    } else {
      const pill =
        document.querySelector(".m_cashback_button .m_cashback_amount") ||
        document.querySelector(".m_cashback_button a");
      const pillText = pill ? pill.textContent : "";
      const balance = readWalletNumber(pillText);
      if (!balance || balance <= 0) {
        note.hidden = true;
        note.dataset.walletUsable = "0";
        applyWalletToTotal();
        return;
      }

      const symbol = readWalletSymbol(pillText);
      // Never advertise more than the order is worth. Cart total is in paise.
      const cartTotal =
        (readWalletNumber(note.dataset.walletCartTotal) || 0) / 100;
      const usable = cartTotal > 0 && cartTotal < balance ? cartTotal : balance;

      text.innerHTML =
        "You are eligible to use <strong>" +
        formatWalletAmount(symbol, usable) +
        "</strong> of <strong>" +
        formatWalletAmount(symbol, balance) +
        "</strong>";
      note.dataset.walletUsable = String(usable);
      note.hidden = false;
    }

    // The drawer is re-rendered wholesale on every cart change, which resets the
    // checkbox — put the shopper's choice back.
    const toggle = note.querySelector("[data-wallet-toggle]");
    if (toggle) toggle.checked = isWalletApplied();

    applyWalletToTotal();
  }

  document.addEventListener("change", function (event) {
    const toggle = event.target.closest("[data-wallet-toggle]");
    if (!toggle) return;
    setWalletApplied(toggle.checked);
    applyWalletToTotal();
  });

  document.addEventListener("DOMContentLoaded", function () {
    fillWalletNote();
    // The wallet app can rewrite the header pill after its own request resolves.
    window.setTimeout(fillWalletNote, 1200);
  });

  // snippets/wallet-balance.liquid fires this once it has the authoritative
  // balance — which on a Kwikpass login is the only time the number is right.
  document.addEventListener("wk:wallet:updated", function () {
    fillWalletNote();
  });

  document.addEventListener("theme:cart:added", function () {
    window.setTimeout(fillWalletNote, 200);
  });

})();
